<template>
  <div v-if="addEditQuestion">
    <template v-if="addEditQuestion.type && addEditQuestion.type.toLowerCase() == 'section'">
      <div :ref="'section_' + addEditQuestion.sequence" v-if="addEditQuestion.type && addEditQuestion.type.toLowerCase() == 'section'" class="section_choice_type">
        <div class="d-flex justify-content-between align-items-center mb-10">
          <div class="col-md-7 pl-0">
            <input placeholder="name" class="group-scoring__name-input pl-5" v-model="addEditQuestion.title" />
          </div>
          <div class="col-md-5 pr-0">
            <div class="row">
              <div class="col-md-12 p-0 text-right">
                <button class="save_sec_btn mr-10 cursor_pointer" style="width: auto" @click="saveQuestion(false)" :disabled="disableSaveBtn">
                  Save
                </button>
                <button class="cancel_sec_btn cursor_pointer" style="width: auto" @click="cancelQuestion">
                  Cancel
                </button>
                <a v-if="addEditQuestion.id" class="cursor_pointer delete-section fs-18" v-on:click="deleteQuestion(addEditQuestion)">
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <div
      v-else
      :style="{
        backgroundColor: addEditQuestion.type === 'multichoice' ? '#f9f9fb' : ''
      }"
    >
      <div class="add_edit_question_card">
        <div class="p-0">
          <div class="row" v-if="addEditQuestion.id && !addQuestion">
            <div class="col-md-4 p-0">
              <p class="question_color">
                <img alt="drag_img" class="drag_img cursor_grab handle" src="static/img/drag.svg" />
                <span class>
                  <b> Step {{ addEditQuestion.stepSequence }}</b></span
                >
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3 p-0">
              <select class="form-control type_select" v-model="addEditQuestion.type" v-on:change="questionTypeChanged(addEditQuestion)">
                <option v-for="questionType in questionInputTypes" :value="questionType.value" :disabled="questionType.value === 'Default'" :selected="questionType.value === 'Default'" :key="questionType.id">
                  {{ questionType.label }}
                </option>
              </select>
            </div>
            <div class="col-lg-6"></div>

            <div class="col-lg-3 pl-0" v-if="activityDetails && activityDetails.hasOwnProperty('completedBy') && activityDetails.completedBy.length > 1 && addEditQuestion.type.toLowerCase() == ''">
              <!-- videorecording -->
              <div class="float-right">
                <label class>
                  <span class>Completed By</span>
                  <select name="completedBy" class="form-control input-md select-completedby mt-10" v-model="addEditQuestion.completedBy">
                    <option value="defaultOption" disabled>Select user type</option>
                    <option v-for="each in activityDetails.completedBy" v-bind:value="each" :key="each">
                      {{ each }}
                    </option>
                  </select>
                </label>
              </div>
            </div>
            <div v-if="addEditQuestion.type && addEditQuestion.type.toLowerCase() == 'gpskin'" class="col-lg-9 col-md-8 col-sm-12 col-xs-12 p-0">
              <div class="example gpskin-example-link mt-8" data-toggle="modal" data-target="#gpSkinScreenExampleModal">
                gpskin screen example
              </div>
            </div>

            <div v-if="addEditQuestion.type && addEditQuestion.type.toLowerCase() == 'skinanalyser'" class="col-lg-9 col-md-8 col-sm-12 col-xs-12 p-0">
              <div class="example gpskin-example-link mt-8" data-toggle="modal" data-target="#skinAnalyserScreenExampleModal">
                Redness and Dryness screen example
              </div>
            </div>

            <div v-if="addEditQuestion.type && addEditQuestion.type.toLowerCase() == 'wongbaker'" class="col-lg-9 col-md-8 col-sm-12 col-xs-12 p-0">
              <span class="fa fa-info-circle info-circle" aria-hidden="true" @click="toggleWongBakerInfoDiv()" tabindex="-1"></span>
              <div class="wong-baker-info-circle-div" v-show="wongBakerInfoDiv">
                The use of the Wong-Baker FACES Pain Rating Scale may require a licensing agreement and fee related to its use. Refer to the following link:
                <a ref="tooltipContent" href="https://wongbakerfaces.org/research-use/" target="_blank" @blur="hideWongBakerPopup">https://wongbakerfaces.org/research-use/</a>.
              </div>
            </div>
          </div>
          <div class v-if="addEditQuestion.type !== 'Default'">
            <div class="options_section" v-if="addEditQuestion.type && addEditQuestion.type.toLowerCase() !== 'surveyinstruction' && addEditQuestion.type.toLowerCase() !== 'surveycompletion'">
              <div class="col-lg-12 p-0">
                <!--MultiChoice type question START-->
                <div v-if="addEditQuestion.type && (addEditQuestion.type.toLowerCase() === 'multichoice' || addEditQuestion.type.toLowerCase() === 'medicationselector')" class="multi_choice_type">
                  <div class>
                    <label class>
                      <input type="checkbox" v-model="addEditQuestion.multipleSelection" name="multipleSelection" />
                      <span class>Allow users to select more than one answer</span>
                    </label>
                  </div>
                  <div v-if="addEditQuestion.type && addEditQuestion.type.toLowerCase() === 'medicationselector'" class>
                    <label class>
                      <input type="checkbox" v-model="addEditQuestion.hasBodyImage" name="hasBodyImage" />
                      <span class>Include an image in the question</span>
                    </label>
                  </div>
                </div>
                <!--MultiChoice type question END-->

                <!--Image type question START-->
                <div v-if="addEditQuestion.type === 'Image'" class="multi_choice_type">
                  <div class>
                    <label class>
                      <input type="checkbox" v-model="addEditQuestion.multipleSelection" name="multipleSelection" />
                      <span class>Allow users to select more than one answer</span>
                    </label>
                  </div>
                </div>
                <!--Image type question END-->

                <!--Boolean type question START-->
                <div v-if="addEditQuestion.type && addEditQuestion.type.toLowerCase() === 'boolean'" class="boolean_choice_type"></div>
                <!--Boolean type question START-->

                <!--Number Scale type question START-->
                <div v-if="addEditQuestion.type && (addEditQuestion.type.toLowerCase() === 'numberscale' || addEditQuestion.type.toLowerCase() === 'vas')" class="scale_choice_type">
                  <div class>
                    <label class="fw-normal">
                      <input type="checkbox" v-model="addEditQuestion.verticalScale" name="verticalScale" />
                      <span class>Vertical scale (scale is horizontal by default)</span>
                    </label>
                  </div>
                </div>
                <!--Number Scale type question END-->

                <!--Custom Scale type question START-->
                <div v-if="addEditQuestion.type && addEditQuestion.type.toLowerCase() === 'customscale'" class="scale_choice_type">
                  <div class>
                    <label class="fw-normal">
                      <input type="checkbox" v-model="addEditQuestion.verticalScale" name="verticalScale" />
                      <span class>Vertical scale (scale is horizontal by default)</span>
                    </label>
                  </div>
                </div>
                <!--Custom Scale type question END-->

                <!--Text type question START-->
                <div v-if="addEditQuestion.type && (addEditQuestion.type.toLowerCase() == 'text' || addEditQuestion.type.toLowerCase() == 'number')" class="text_choice_type">
                  <label class="fw-normal">
                    <input type="checkbox" v-model="addEditQuestion.characterLimited" name="characterLimited" />
                    <span class="position_relative">Character limit</span>
                    <input type="number" class="form-control form-control-sm input-style limit_text_input mt-5" v-model="addEditQuestion.textLimit" placeholder="Enter limit" min="1" max="512" :disabled="!addEditQuestion.characterLimited" v-on:input="validateCharacterLimit(addEditQuestion, addEditQuestion.textLimit)" />
                  </label>
                </div>
                <!--Text type question END-->

                <!--Log Type question START-->
                <div
                  v-if="
                    addEditQuestion.type &&
                      addEditQuestion.type !== 'Default' &&
                      addEditQuestion.type !== 'surveyinstruction' &&
                      addEditQuestion.type.toLowerCase() !== 'validatedentry' &&
                      addEditQuestion.type !== 'WongBaker' &&
                      addEditQuestion.type.toLowerCase() !== 'medicationselector' &&
                      addEditQuestion.type !== 'AudioRecording' &&
                      addEditQuestion.type !== 'VideoRecording' &&
                      addEditQuestion.type !== 'GPSkin'
                  "
                  class="text_choice_type"
                >
                  <label class="fw-normal">
                    <input type="checkbox" v-model="addEditQuestion.isDataMapped" @change="removeDataMapKey($event)" name="isDataMapped" />
                    <span class="position_relative"
                      >Map data
                      <input
                        type="text"
                        name="mapLabel"
                        class="form-control form-control-sm input-style limit_text_input mt-5"
                        :class="{
                          input: true,
                          'is-danger': errors.has('mapLabel') || notValidMapKey,
                          'is-success': !errors.has('mapLabel') || notValidMapKey
                        }"
                        v-model="addEditQuestion.mapLabel"
                        v-validate="{
                          required: addEditQuestion.isDataMapped,
                          regex: /^[A-Za-z0-9_@\./#&+-]*$/
                        }"
                        @change="validateMapLabelOnChange($event, addEditQuestion.id)"
                        @blur="validateMapLabelOnChange($event, addEditQuestion.id)"
                        placeholder="Enter field name"
                        :disabled="!addEditQuestion.isDataMapped"
                      />
                    </span>
                  </label>
                  <span class="fa fa-info-circle info-circle" aria-hidden="true" @click="toggleMapInfoDiv()" @blur="hideMapPopup()" tabindex="-1"></span>
                  <div class="map-info-circle-div" v-show="mapinfoDiv">
                    You may name this field for the purposes of data mapping. It will not be visible to the Site Team(s) or participants.
                  </div>
                </div>
                <!--Log Type question END-->

                <!--Number type question START-->
                <div v-if="addEditQuestion.type && addEditQuestion.type.toLowerCase() === 'number'" class="number_choice_type">
                  <label class="fw-normal display-block width-40">
                    <div class="">
                      <input type="checkbox" v-model="addEditQuestion.hasUnits" name="hasUnits" />
                      <span class="position_relative">
                        Answer label
                        <input type="text" class="form-control form-control-sm input-style limit_text_input answer_label_text_input" placeholder="ex. mins, lbs, days" v-model="addEditQuestion.units" :disabled="!addEditQuestion.hasUnits" />
                      </span>
                    </div>
                  </label>
                  <label class="fw-normal display-block width-50">
                    <div class="">
                      <input type="checkbox" v-model="addEditQuestion.hasAnswerlabelunits" name="hasAnswerlabelunits" />
                      <span class="position_relative">
                        Units
                        <input type="text" class="form-control form-control-sm input-style limit_text_input answer_label_text_input unit_input" placeholder="ex. inches, feet" v-model="addEditQuestion.answerlabelunits" :disabled="!addEditQuestion.hasAnswerlabelunits" />
                      </span>
                    </div>
                  </label>
                  <label class="fw-normal display-block width-40">
                    <div class="">
                      <input type="checkbox" v-model="addEditQuestion.hasMinMax" name="subType" />
                      <span class="position_relative">
                        Min/max value
                        <input type="number" class="form-control form-control-sm input-style limit_text_input min_value_input" v-model="addEditQuestion.minValue" placeholder="min" min="1" max="2048" :disabled="!addEditQuestion.hasMinMax" />
                        <span class="min_max_to_text">to</span>
                        <input type="number" class="form-control form-control-sm input-style limit_text_input max_value_input" v-model="addEditQuestion.maxValue" placeholder="max" min="1" max="2048" :disabled="!addEditQuestion.hasMinMax" />
                      </span>
                    </div>
                  </label>
                  <label class="fw-normal display-block width-50">
                    <div class="">
                      <input type="checkbox" v-model="addEditQuestion.hasSoftMinMax" name="subType" />
                      <span class="position_relative">
                        Soft min/max value
                        <input type="number" class="form-control form-control-sm input-style limit_text_input soft_min min_value_input" v-model="addEditQuestion.softminValue" placeholder="min" min="1" max="2048" :disabled="!addEditQuestion.hasSoftMinMax" />
                        <span class="soft_min_to min_max_to_text">to</span>
                        <input type="number" class="form-control form-control-sm input-style limit_text_input soft_max max_value_input" v-model="addEditQuestion.softmaxValue" placeholder="max" min="1" max="2048" :disabled="!addEditQuestion.hasSoftMinMax" />
                      </span>
                    </div>
                  </label>
                  <div class="clearfix" />
                  <label class="fw-normal display-block">
                    <input type="checkbox" v-model="addEditQuestion.allowNegative" name="allowNegative" />
                    <span class="position_relative">Allow negative value</span>
                  </label>
                  <label class="fw-normal display-block">
                    <input type="checkbox" v-model="addEditQuestion.allowDecimals" value="Single" name="subType" @change="changeValidation('DECIMAL', $event)" />
                    <span class="position_relative"
                      >Allow decimals
                      <input v-if="addEditQuestion.allowDecimals" type="number" class="form-control form-control-sm input-style mt-5 limit_text_input" v-model="addEditQuestion.decimalValue" placeholder="Decimal Places" />
                    </span>
                  </label>
                </div>
                <!--Number type question END-->

                <!--DateTime type question START-->
                <div v-if="addEditQuestion.type && addEditQuestion.type.toLowerCase() == 'datetime'" class="date_time_type">
                  <div class="radio radio-style m-0">
                    <label class="pl-0">
                      <input type="checkbox" v-model="addEditQuestion.showDate" v-on:click="setDateSelection($event)" />
                      <span>Date</span>
                    </label>
                    <label class>
                      <input name="dateFormat" type="radio" v-model="addEditQuestion.dateFormat" value="mm/dd/yyyy" :disabled="!addEditQuestion.showDate" />
                      mm/dd/yyyy
                    </label>
                    <label class>
                      <input type="radio" name="dateFormat" v-model="addEditQuestion.dateFormat" value="dd/mm/yyyy" :disabled="!addEditQuestion.showDate" />
                      dd/mm/yyyy
                    </label>
                    <label class>
                      <input type="radio" name="dateFormat" v-model="addEditQuestion.dateFormat" value="yyyy/mm/dd" :disabled="!addEditQuestion.showDate" />
                      yyyy/mm/dd
                    </label>
                    <label class>
                      <input type="radio" name="dateFormat" v-model="addEditQuestion.dateFormat" value="yyyy/mm" :disabled="!addEditQuestion.showDate" />
                      yyyy/mm
                    </label>
                    <label class>
                      <input type="radio" name="dateFormat" v-model="addEditQuestion.dateFormat" value="mm/yyyy" :disabled="!addEditQuestion.showDate" />
                      mm/yyyy
                    </label>
                    <label class>
                      <input type="radio" name="dateFormat" v-model="addEditQuestion.dateFormat" value="yyyy" :disabled="!addEditQuestion.showDate" />
                      yyyy
                    </label>
                  </div>
                  <div class="radio radio-style m-0">
                    <label class="pl-0">
                      <input type="checkbox" v-model="addEditQuestion.showDateRange" v-on:click="setDateRangeSelection($event)" />
                      <span class="pr-20">Set a date range</span>
                    </label>
                    <label class="pr-10">
                      <input type="radio" name="dateRange" v-model="addEditQuestion.dateRange" value="0" :disabled="!addEditQuestion.showDateRange" @change="dateRangeChanged()" />
                      Start and end dates
                    </label>
                    <label class>
                      <input type="radio" name="dateRange" v-model="addEditQuestion.dateRange" value="1" :disabled="!addEditQuestion.showDateRange" @change="dateRangeChanged()" />
                      +/- Deviation
                    </label>
                  </div>
                  <div class="radio radio-style m-0">
                    <label class="pl-0">
                      <input type="checkbox" v-model="addEditQuestion.showTime" v-on:click="setTimeSelection($event)" />
                      <span>Time</span>
                    </label>
                    <label class>
                      <input type="radio" name="timeFormat" v-model="addEditQuestion.timeFormat" value="12" :disabled="!addEditQuestion.showTime" />
                      AM/PM
                    </label>
                    <label class>
                      <input type="radio" name="timeFormat" v-model="addEditQuestion.timeFormat" value="24" :disabled="!addEditQuestion.showTime" />
                      24 HR
                    </label>
                  </div>
                  <div class="radio radio-style m-0">
                    <label class="pl-0">
                      <input type="checkbox" v-model="addEditQuestion.showTimeRange" v-on:click="setTimeRangeSelection($event)" />
                      <span class="pr-20">Set a time range</span>
                    </label>
                    <label class="pr-10">
                      <input type="radio" name="timeRange" v-model="addEditQuestion.timeRange" value="0" :disabled="!addEditQuestion.showTimeRange" @change="timeRangeChanged" />
                      Start and end time
                    </label>
                    <label class>
                      <input type="radio" name="timeRange" v-model="addEditQuestion.timeRange" value="1" :disabled="!addEditQuestion.showTimeRange" @change="timeRangeChanged" />
                      +/- Deviation
                    </label>
                  </div>
                </div>
                <!--DateTime type question END-->
                <div>
                  <label class="fw-normal" v-if="addEditQuestion.type && addEditQuestion.type.toLowerCase() == 'imagecapture'">
                    <input type="checkbox" v-model="addEditQuestion.guideParticipant" />
                    <span class>Guide participant using a template image during photo capture. </span>
                  </label>
                </div>
                <div>
                  <label class="fw-normal" v-if="addEditQuestion.type && addEditQuestion.type.toLowerCase() == 'index'">
                    <input type="checkbox" v-model="addEditQuestion.allowCrossFormValidation" />
                    <span class>Create Cross Form Validation</span>
                  </label>
                </div>
                <div>
                  <label class="fw-normal" v-if="addEditQuestion.type && addEditQuestion.type.toLowerCase() == 'index'">
                    <input type="checkbox" v-model="addEditQuestion.allowRepeatEntry" />
                    <span class>Allow for repeat entry</span>
                  </label>
                </div>
                <div class="d-inline-block">
                  <label
                    class="fw-normal"
                    v-if="
                      addEditQuestion.type &&
                        addEditQuestion.type.toLowerCase() !== 'surveyinstruction' &&
                        addEditQuestion.type.toLowerCase() !== 'surveycompletion' &&
                        (addEditQuestion.type.toLowerCase() == 'audiorecording' ||
                          addEditQuestion.type.toLowerCase() == 'videorecording' ||
                          addEditQuestion.type.toLowerCase() == 'customscale' ||
                          addEditQuestion.type.toLowerCase() == 'datetime' ||
                          addEditQuestion.type.toLowerCase() == 'dropdown' ||
                          addEditQuestion.type.toLowerCase() == 'imagecapture' ||
                          addEditQuestion.type.toLowerCase() == 'image' ||
                          addEditQuestion.type.toLowerCase() == 'index' ||
                          addEditQuestion.type.toLowerCase() == 'log' ||
                          addEditQuestion.type.toLowerCase() == 'measurements' ||
                          addEditQuestion.type.toLowerCase() == 'medicationselector' ||
                          addEditQuestion.type.toLowerCase() == 'multichoice' ||
                          addEditQuestion.type.toLowerCase() == 'number' ||
                          addEditQuestion.type.toLowerCase() == 'numberscale' ||
                          addEditQuestion.type.toLowerCase() == 'text' ||
                          addEditQuestion.type.toLowerCase() == 'validatedentry' ||
                          addEditQuestion.type.toLowerCase() == 'videorecording' ||
                          addEditQuestion.type.toLowerCase() == 'vas' ||
                          addEditQuestion.type.toLowerCase() == 'wongbaker' ||
                          addEditQuestion.type.toLowerCase() == 'boolean' ||
                          addEditQuestion.type.toLowerCase() == 'gpskin' ||
                          addEditQuestion.type.toLowerCase() == 'skinanalyser')
                    "
                  >
                    <input type="checkbox" v-model="addEditQuestion.isSkippable" />
                    <span class>Make step optional</span>
                  </label>
                </div>
                <div class="d-inline-block ml-30 position-absolute" v-if="showScoreWhenSkipped">
                  <label class="float-left">Score when skipped</label>
                  <div class="float-left ml-10 score_skiped">
                    <integer-plusminus :min="0" :max="999" :step="1" :vertical="false" formName="score" class="" v-model.number="addEditQuestion.skipScore">
                      <input value="999" v-model.number="addEditQuestion.skipScore" oninput="javascript: this.value = Math.abs(this.value); this.value = Math.round(this.value); if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" type="number" maxlength="3" class="integer-plus-minus-input pt-5" />
                    </integer-plusminus>
                  </div>
                </div>

                <div>
                  <label class="fw-normal" v-if="addEditQuestion.type && addEditQuestion.type.toLowerCase() == 'audiorecording'">
                    <input type="checkbox" v-model="addEditQuestion.audioSkippable" />

                    <span class>Make audio optional</span>
                  </label>
                  <label class="fw-normal" v-if="addEditQuestion.type && addEditQuestion.type.toLowerCase() == 'videorecording'">
                    <input type="checkbox" v-model="addEditQuestion.videoSkippable" />
                    <span class>Make video optional</span>
                  </label>
                </div>
                <div v-if="addEditQuestion.type && (addEditQuestion.type.toLowerCase() == 'videorecording' || addEditQuestion.type.toLowerCase() == 'audiorecording')" class="d-flex">
                  <label class="fw-normal">
                    <input type="checkbox" v-model="addEditQuestion.hasMaxTimeLimit" :value="true" @change="resetMaxRecordTime" />
                    <span>Max recording time limit</span>
                  </label>
                  <template v-if="addEditQuestion.hasMaxTimeLimit">
                    <label class="ml-20">
                      <input v-model.number="addEditQuestion.maxMinutes" type="number" placeholder="MM" class="d-inline-block text-center" min="0" max="60" @input="validateMinutes" />
                      Minutes,
                    </label>
                    <label class="ml-10">
                      <input v-model.number="addEditQuestion.maxSeconds" type="number" placeholder="SS" class="d-inline-block text-center" min="0" max="60" @input="validateSeconds" />
                      <span class="ml-5 mr-5">Seconds</span>
                    </label>
                  </template>
                </div>
                <div>
                  <label class="fw-normal" v-if="addEditQuestion.type && addEditQuestion.type.toLowerCase() == 'log' && (addEditQuestion.type.toLowerCase() == 'measurements' || addEditQuestion.type.toLowerCase() == 'validatedentry')">
                    <input type="checkbox" v-model="addEditQuestion.isCrossFormVaildation" />
                    <span class>Create cross form vaildation</span>
                  </label>
                </div>
                <div>
                  <label class="fw-normal" v-if="addEditQuestion.type && (addEditQuestion.type.toLowerCase() == 'measurements' || addEditQuestion.type.toLowerCase() == 'text' || addEditQuestion.type.toLowerCase() == 'log' || addEditQuestion.type.toLowerCase() == 'validatedentry') && addEditQuestion.type.toLowerCase() !== 'surveyinstruction'">
                    <input type="checkbox" v-model="addEditQuestion.isRepeatEntry" />
                    <span class>Allow for repeat entry</span>
                  </label>
                </div>
                <div class v-if="addEditQuestion.type && addEditQuestion.type.toLowerCase() === 'multichoice'">
                  <label class>
                    <input type="checkbox" v-model="addEditQuestion.isColorCodeEnabled" name="hasBodyImage" />
                    <span class>Add color-coded alerts to answers for the study team</span>
                  </label>
                </div>
                <div class v-if="addEditQuestion.type && addEditQuestion.type == 'Index'">
                  <label class>
                    <input type="checkbox" v-model="addEditQuestion.isNotifyToEmail" v-on:click="toggleNotifyToEmail(addEditQuestion.isNotifyToEmail)" class="toggle-checkbox" />
                    <span class="email-label">Flag question as a log entry </span>
                  </label>
                  <span class="fa fa-info-circle info-circle" aria-hidden="true" @click="toggleInfoDiv()" @blur="hidePopup()" tabindex="-1"></span>
                  <div class="info-circle-div" v-show="infoDiv">
                    When a participant completes this activity, flagged steps and the results will be emailed to one or more recipients who are identified when you schedule this activity.
                  </div>
                </div>
                <div
                  class
                  v-if="
                    (addEditQuestion.type && addEditQuestion.type !== 'Default' && addEditQuestion.type !== 'Log' && addEditQuestion.type.toLowerCase() !== 'measurements' && addEditQuestion.type.toLowerCase() !== 'index') ||
                      addEditQuestion.type.toLowerCase() == 'validatedentry' ||
                      addEditQuestion.type.toLowerCase() == 'gpskin' ||
                      addEditQuestion.type == 'WongBaker' ||
                      addEditQuestion.type.toLowerCase() === 'medicationselector' ||
                      addEditQuestion.type.toLowerCase() == 'audiorecording' ||
                      addEditQuestion.type.toLowerCase() == 'videorecording' ||
                      addEditQuestion.type.toLowerCase() == 'skinanalyser'
                  "
                >
                  <label class>
                    <input type="checkbox" v-model="addEditQuestion.isNotifyToEmail" v-on:click="toggleNotifyToEmail(addEditQuestion.isNotifyToEmail)" class="toggle-checkbox" />
                    <span class="email-label">Flag question and participant answer to be included in recipient email. </span>
                  </label>
                  <span class="fa fa-info-circle info-circle" aria-hidden="true" @click="toggleInfoDiv('email')" @blur="hidePopup('email')" tabindex="-1"></span>
                  <div class="info-circle-div" v-show="infoDiv">
                    When a participant completes this activity, flagged steps and the results will be emailed to one or more recipients who are identified when you schedule this activity.
                  </div>
                </div>
                <div class v-if="addEditQuestion.type && addEditQuestion.type.toLowerCase() === 'medicationselector'">
                  <label class>
                    <input type="checkbox" v-model="addEditQuestion.allowImageCollection" class="toggle-checkbox" />
                    <span class="position_relative">Allow image collection of medication </span>
                  </label>
                </div>
                <div class v-if="addEditQuestion.type && addEditQuestion.type.toLowerCase() === 'medicationselector'">
                  <label class>
                    <input type="checkbox" v-model="addEditQuestion.canCollectReason" class="toggle-checkbox" />
                    <span class="position_relative">Collect reason(s) for use </span>
                  </label>
                  <span class="fa fa-info-circle info-circle" aria-hidden="true" @click="toggleInfoDiv('mediReason')" @blur="hidePopup('mediReason')" tabindex="-1"></span>
                  <div class="info-circle-div" v-show="mediInfoDiv">
                    Requires the participant to select a reason for use when entering the medication.
                  </div>
                </div>
                <div v-if="this.activityData.prePopulationEnabled" class>
                  <label class>
                    <input type="checkbox" v-model="addEditQuestion.hasPreviousResponses" name="hasPreviousResponses" />
                    <span class>Allow participant to view previous responses</span>
                  </label>
                </div>
                <div v-if="addEditQuestion.type && addEditQuestion.type.toLowerCase() === 'vas'" class="scale_choice_type">
                  <div class>
                    <label class="fw-normal">
                      <input type="checkbox" v-model="addEditQuestion.isScaleType" name="verticalScale" @click="scaleDisplayType = 'VAS'" />
                      <span class>Use a custom VAS Scale</span>
                    </label>
                  </div>
                </div>
                <!--------------------Checkbox for using english languages images option for other langugaes ----------------- -->
                <div v-if="addEditQuestion.type === 'Image' && activityData.language.length > 1" class="use-english-img">
                  <label>
                    <input type="checkbox" v-model="addEditQuestion.useEnglishImageAnswer" class="toggle-checkbox" @change="toggleUseEnglishImageAnswerCheckbox()" />
                    <span>Use English image answer choices for all languages.</span>
                  </label>
                  <span class="fa fa-info-circle info-circle" aria-hidden="true" @click="toggleEnglishImageInfoDiv()" @blur="toggleEnglishImageInfoDiv(true)" tabindex="-1"></span>
                  <div class="info-circle-div" v-show="useEnglishImageInfoDiv">
                    Leaving this box unchecked will require separate image sets to be uploaded for each additional language.
                  </div>
                </div>
                <div v-if="activityData.dataChecksForResponses && (addEditQuestion.type.toLowerCase() == 'measurements' || addEditQuestion.type.toLowerCase() == 'number' || addEditQuestion.type.toLowerCase() == 'text' || addEditQuestion.type.toLowerCase() == 'datetime')" class>
                  <label>
                    <input type="checkbox" v-model="addEditQuestion.isDataCheckConfigured" @change="changeValidation('DATACHECK', $event)" class="toggle-checkbox" />
                    <span class="position_relative">Configure data checks </span>
                  </label>

                  <div class="row show-dropdown p-3" v-for="(item, index) in configureDataCheck" :key="index">
                    <div class="col-sm-2 mr-10">
                      <select
                        class="form-control type_select mt-5"
                        name="dataChecks"
                        v-if="addEditQuestion.isDataCheckConfigured"
                        v-model="item.check"
                        @change="
                          item.showDataCheckTypeDropdown = true;
                          updateDataChecks();
                        "
                        :disabled="index < configureDataCheck.length - 1 && !editFlag"
                      >
                        <option disabled value="">Select type</option>
                        <option v-for="checks in dataChecks" v-bind:value="checks.value" :key="checks.value">
                          {{ checks.name }}
                        </option>
                      </select>
                    </div>
                    <div v-if="item.showDataCheckTypeDropdown">
                      <div class="col-sm-2 mr-25">
                        <select
                          name="configureData"
                          class="form-control type_select mt-5"
                          v-model="item.type"
                          v-if="addEditQuestion.isDataCheckConfigured"
                          @change="
                            item.showDataCheckTypeDropdown = true;
                            updateDataChecks();
                          "
                        >
                          <option value="" selected disabled>Select validation</option>
                          <slot v-for="configureData in questionTypesvalidationcheck.filter(questionTypeValidation => addEditQuestion.type == questionTypeValidation.value)">
                            <option v-for="validatetype in configureData.validatetype" v-bind:value="validatetype" :key="validatetype" :disabled="item.check == 'SOFT' ? currentSoftDataChecks.includes(validatetype) : currentHardDataChecks.includes(validatetype)">
                              {{ validatetype | removeSpecialCharacters }}
                            </option>
                          </slot>
                        </select>
                      </div>
                      <div v-if="item.type != 'DATA_TYPE' && item.type != 'NOT_BLANK' && item.type != null && item.type != 'DATA_FORMAT' && item.type != '' && addEditQuestion.isDataCheckConfigured == true">
                        <input v-if="addEditQuestion.type && addEditQuestion.type.toLowerCase() != 'datetime'" type="number" placeholder="Enter value" class="col-sm-2 mr-15 form-control form-control-sm input-style limit_select_input mt-5 pb-3 pt-3" v-model="item.value" />
                        <div v-else>
                          <datepicker v-if="addEditQuestion.showDate" :use-utc="true" input-class="inner-card-value" class="col-sm-2 mr-15 form-control form-control-sm input-style limit_select_input mt-5 pb-3 pt-3" v-model="item.dateValue" name="endDate" :format="addEditQuestion.dateFormat.replace('mm', 'MM')"></datepicker>
                          <vue-timepicker v-if="addEditQuestion.showTime" v-model="item.timeValue" name="endTime" hide-clear-button input-class="inner-card-value" class="col-sm-2 mr-15 input-style limit_select_input mt-5 pb-3 pt-3" :format="addEditQuestion.timeFormat == '12' ? 'hh:mm A' : 'HH:mm'"></vue-timepicker>
                        </div>
                      </div>
                      <div v-else-if="item.type == 'DATA_FORMAT' && item.type != '' && addEditQuestion.isDataCheckConfigured == true">
                        <b-form-input class="col-sm-2 mr-15 form-control form-control-sm input-style limit_select_input mt-5 pb-3 pt-3" type="text" v-model="item.value" :formatter="dataFormatNumber" />
                      </div>
                      <div v-else-if="item.type == 'DATA_TYPE' && addEditQuestion.isDataCheckConfigured == true">
                        <select class="col-sm-2 mr-15 form-control type_select mt-6 pb-3 pt-3" v-model="item.value">
                          <option disabled value="">Select data type</option>
                          <slot v-for="configureData in questionTypesvalidationcheck.filter(questionTypeValidation => addEditQuestion.type == questionTypeValidation.value)">
                            <option v-for="datatype in configureData.dataValidationType" v-bind:value="datatype" :key="datatype" :disabled="addEditQuestion.allowDecimals == true && datatype == 'Numeric'">
                              {{ datatype | removeSpecialCharacters }}
                            </option>
                          </slot>
                        </select>
                      </div>
                      <div v-else class="col-sm-2 mr-8"></div>
                      <div class="col-sm-1 pl-0 delete_button color_red">
                        <img alt="delete" class="btn btn-link pt-5 pl-0 mt-5 mr-5 p-0" @click="removeDataCheck(index)" v-if="addEditQuestion.isDataCheckConfigured == true && configureDataCheck.length > 1" src="static/img/delete.svg" />
                      </div>
                      <div class="col-sm-3 pl-0 pt-10">
                        <span v-if="index == configureDataCheck.length - 1 && addEditQuestion.isDataCheckConfigured == true" @click="addAnotherDataCheck(index)" class="add_another_data_check">Add another data check</span>
                        <p v-else>&nbsp;</p>
                      </div>
                    </div>
                    <div v-else>
                      <div class="col-sm-10"></div>
                    </div>
                  </div>
                  <!-- Row ends -->
                </div>
                <div v-if="addEditQuestion.type.toLowerCase() == 'numberscale'">
                  <label>
                    <input type="checkbox" v-model="addEditQuestion.numericRatingScale" class="toggle-checkbox" />
                    <span class="position_relative">Numeric Rating Scale (switches from the numeric slider to individual boxes) </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="pt-0 pb-2 clearfix"
          v-if="
            addEditQuestion.type &&
              addEditQuestion.type !== 'Default' &&
              addEditQuestion.type.toLowerCase() !== 'surveyinstruction' &&
              addEditQuestion.type.toLowerCase() !== 'audiorecording' &&
              addEditQuestion.type.toLowerCase() !== 'videorecording' &&
              addEditQuestion.type.toLowerCase() !== 'surveycompletion' &&
              addEditQuestion.type.toLowerCase() !== 'gpskin' &&
              addEditQuestion.type.toLowerCase() !== 'imagecapture' &&
              addEditQuestion.type !== 'WongBaker' &&
              addEditQuestion.type.toLowerCase() !== 'skinanalyser'
          "
        >
          <h5 class="question mb-0">Question</h5>
          <div class="clearfix" />
        </div>

        <ActivityStepsEdit
          v-if="addEditQuestion && activityDetails"
          :question="addEditQuestion"
          :activityDetails="activityDetails"
          :editorOptionForQuestion="editorOptionForQuestion"
          :editorOptionForLabel="editorOptionForLabel"
          :editorOptionForValue="editorOptionForValue"
          :audioSkippable="addEditQuestion.audioSkippable"
          :videoSkippable="addEditQuestion.videoSkippable"
          ref="activityStepsEdit"
          :key="keyToUpdateActivityEditComponent"
        />

        <!-- image capture lbraryr modal-->
        <div id="myModal" class="modal fade model-size" role="dialog" data-backdrop="static">
          <div class="modal-dialog model-lg">
            <div class="modal-content modal_custom image-capture-model col-lg-12 col-md-12 col-sm-12 col-xs-12 pt-30 pb-30 pr-30 pl-30">
              <div class="row">
                <a class="cancelImage cursor_pointer pt-10" v-on:click="cancelImages">
                  <i class="fa fa-times" aria-hidden="true"></i>
                </a>
              </div>
              <div class="fs-28 text-center modal_header_color fw-200">
                Template Image Library
              </div>
              <p class="modal_desc text-center">Choose an image</p>
              <div class="row pt-0">
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 pl-0 pr-0" v-for="(i, index) in logos" v-on:click="selectLogo(i, index)" :key="i.id">
                  <div
                    class="library_img_bg"
                    :class="{
                      selected_icon_logo_image: i.name === selectedTemplateImageIcon.name
                    }"
                  >
                    <img alt="responsive" class="img-responsive icon" :src="i.preSignedURL" />
                  </div>
                </div>
              </div>
              <div class="row text-center pt-10" v-if="totalPages > 1">
                <span class="paginate" v-if="currentPage !== 1" v-on:click="getLogosFromLibrary(currentPage - 1)">
                  <i class="fa fa-chevron-left" aria-hidden="true"></i>
                </span>
                <span class="paginate" :class="{ active: currentPage === pageIndex + 1 }" v-for="(page, pageIndex) in totalPages" v-on:click="getLogosFromLibrary(pageIndex + 1)" :key="page.id">{{ pageIndex + 1 }}</span>
                <span class="paginate" v-if="currentPage !== totalPages" v-on:click="getLogosFromLibrary(currentPage + 1)">
                  <i class="fa fa-chevron-right" aria-hidden="true"></i>
                </span>
              </div>
              <div class="row pt-10 text-center">
                <button class="btn btn-info btn-block text-center color_ff br-25 library_add_btn" v-on:click="addImage()" :disabled="!selectedTemplateImageIcon || !selectedTemplateImageIcon.preSignedURL">
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Measurements question type start -->

        <!-- Measurements question type end -->
        <!-- end -->
        <div class="row clearfix pt-10">
          <div class="col-lg-4 p-0">
            <button class="btn btn-link color_red pl-0" v-on:click="deleteQuestion(addEditQuestion)" :disabled="addEditQuestion.type === 'Default'" v-if="addEditQuestion.id">
              <img alt="delete" src="static/img/delete.svg" />
            </button>
          </div>
          <div class="col-lg-offset-4 col-lg-4 text-right p-0" style="white-space: nowrap; float: right">
            <button class="btn btn-link br-25" v-on:click="cancelQuestion()" :disabled="allQuestions && allQuestions.length === 0">
              Cancel
            </button>
            <button class="btn btn-success save_btn br-25" v-on:click="saveQuestion(false)" :disabled="addEditQuestion.type === 'Default'">
              Save
            </button>
          </div>
        </div>
        <div id="instructionModal" class="modal fade" role="dialog">
          <div class="modal-dialog">
            <!-- Modal content-->
            <div class="modal-content pt-15 pb-30 pl-30 pr-15">
              <div>
                <i class="fa fa-times cancelImage" aria-hidden="true" @click="closeModal()"></i>
              </div>
              <div class="pr-15 pt-20">
                <img alt="graphic" src="static/img/graphic-instruction-example.png" />
              </div>
            </div>
          </div>
        </div>
        <div id="gpSkinScreenExampleModal" class="modal fade" role="dialog">
          <div class="modal-dialog">
            <!-- Modal content-->
            <div class="modal-content pt-15 pb-30 pl-30 pr-15">
              <div>
                <i class="fa fa-times cancelImage" aria-hidden="true" data-dismiss="modal"></i>
              </div>
              <div class="pr-15 pt-20">
                <img alt="skin-health" src="static/img/skin-health-activity/gpSkinExampleScreen.png" />
              </div>
            </div>
          </div>
        </div>
        <div id="imageCpatureExampleModal" class="modal fade" role="dialog">
          <div class="modal-dialog modal-sm">
            <!-- Modal content-->
            <div class="modal-content pt-15 pb-30 pl-30 pr-15">
              <div>
                <i class="fa fa-times cancelImage" aria-hidden="true" data-dismiss="modal"></i>
              </div>
              <div class="pr-15 pt-20">
                <div class="modal-heading-text">
                  This is a sample of an image template used to guide participants.
                </div>
                <div class="img-border">
                  <img alt="template" class="img-fluid" src="static/img/template-example.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="instructionScreenExampleModal" class="modal fade" role="dialog">
          <div class="modal-dialog modal-sm">
            <!-- Modal content-->
            <div class="modal-content pt-15 pb-30 pl-30 pr-15">
              <div>
                <i class="fa fa-times cancelImage" aria-hidden="true" data-dismiss="modal"></i>
              </div>
              <div class="pr-15 pt-20">
                <div class="img-border">
                  <img alt="empty-example" class="img-fluid" src="static/img/empty-example.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="skinAnalyserScreenExampleModal" class="modal fade" role="dialog">
          <div class="modal-dialog">
            <!-- Modal content START-->
            <div class="modal-content pt-15 pb-30 pl-30 pr-15">
              <div>
                <i class="fa fa-times cancelImage" aria-hidden="true" data-dismiss="modal"></i>
              </div>
              <div class="pr-15 pt-20">
                <img alt="skin-health" src="static/img/skin-health-activity/skinAnalyserExampleScreen.png" />
              </div>
            </div>
            <!-- Modal content END-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import toastr from "toastr";
import swal from "sweetalert2";
import Datepicker from "vuejs-datepicker";
import { IntegerPlusminus } from "vue-integer-plusminus";
import moment from "moment";
import VueTimepicker from "vue2-timepicker";

// STEPS
import ActivityStepsEdit from "@/components/activity-library/activity-steps/activity-steps-edit";
import { v4 as uuidv4 } from "uuid";
import QlVideoUploadService from "@/services/ql-video-upload";
import localStorage from "@/services/localStorage";
import { BranchingHelper } from "@/components/activity-library/branching-helper";
import * as activityService from "@/components/services/activity-service";
import MultiSelectWithSearch from "@/components/activity-library/multi-select-with-search";

const MODULE_NAME = "activity";
export default {
  name: "add-edit-questions",
  data() {
    return {
      isScaleType: false,
      scaleDisplayType: null,
      showDataCheckDropdown: false,
      currentQuestionType: "",
      configureDataCheck: [],
      dataChecks: [
        { value: "SOFT", name: "Soft data checks" },
        { value: "HARD", name: "Hard data checks" }
      ],
      currentSoftDataChecks: [],
      currentDataChecks: [],
      currentHardDataChecks: [],
      editFlag: false,
      dataCheckType: "",
      selectValidatetype: null,
      eventListenerToHideSectionBox: null,
      wongBakerInfoDiv: false,
      infoDiv: false,
      mediInfoDiv: false,
      mapinfoDiv: false,
      scaleInfoDiv: false,
      entries: [],
      logEntryInfoDiv: false,
      intervalInfoDiv: false,
      scoreInfoDiv: false,
      activityTypes: [],
      lengthInfoDiv: false,
      pointerInfoDiv: false,
      scaleValueInfoDiv: false,
      restrainInfoDiv: false,
      activityDetails: null,
      canRestrainLength: false,
      isDanger: false,
      intervals: [
        { name: " ", value: "0" },
        { name: "1", value: "1" },
        { name: "2", value: "2" },
        { name: "3", value: "3" },
        { name: "4", value: "4" },
        { name: "5", value: "5" },
        { name: "6", value: "6" },
        { name: "7", value: "7" },
        { name: "8", value: "8" },
        { name: "9", value: "9" },
        { name: "10", value: "10" },
        { name: "11", value: "11" },
        { name: "12", value: "12" },
        { name: "13", value: "13" }
      ],
      questionTypes: _.sortBy(
        [
          {
            value: "Default",
            label: "- Select a screen type -",
            facingType: "both"
          },
          {
            value: "SurveyInstruction",
            label: "Instruction screen",
            facingType: "both"
          },
          { value: "CustomScale", label: "Custom scale", facingType: "both" },
          { value: "DateTime", label: "Date / Time", facingType: "both" },
          { value: "DropDown", label: "Drop-down", facingType: "both" },
          {
            value: "GPSkin",
            label: "gpskin Barrier device scan",
            facingType: "participant"
          },
          {
            value: "ImageCapture",
            label: "Image capture",
            facingType: "participant"
          },
          { value: "Image", label: "Image choice", facingType: "both" },
          { value: "Index", label: "Index", facingType: "site" },
          { value: "Log", label: "Log Entry", facingType: "site" },
          { value: "Measurements", label: "Measurements", facingType: "site" },
          {
            value: "MedicationSelector",
            label: "Medication Selector",
            facingType: "participant"
          },
          {
            value: "MultiChoice",
            label: "Multiple choice",
            facingType: "both"
          },
          { value: "Number", label: "Number Response", facingType: "both" },
          { value: "NumberScale", label: "Number Scale", facingType: "both" },
          { value: "Text", label: "Text Response", facingType: "both" },
          {
            value: "ValidatedEntry",
            label: "Validated Entry",
            facingType: "site"
          },
          {
            value: "VAS",
            label: "Visual analog scale",
            facingType: "participant"
          },
          { value: "Boolean", label: "Yes or No", facingType: "both" },
          {
            value: "WongBaker",
            label: "Wong-Baker FACES Pain Rating Scale",
            facingType: "participant"
          },
          {
            value: "AudioRecording",
            label: "Audio Recording",
            facingType: "participant"
          },
          {
            value: "VideoRecording",
            label: "Video Recording",
            facingType: "participant"
          },
          // { value: "SurveyCompletion", label: "Custom Completion Screen" },
          // { value: 'Email', label: 'Email' },
          // { value: 'Location', label: 'Location' },
          {
            value: "SkinAnalyser",
            label: "Redness and Dryness Assessment",
            facingType: "participant"
          }
        ],
        [type => type.label.toLowerCase()],
        ["asc"]
      ),
      validLabels: [],
      addEditQuestion: this.options,
      allQuestions: null,
      bodyImages: [],
      editorOption: {
        placeholder: "Enter content for this topic",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], [{ align: [] }], ["clean"]]
        }
      },
      editorOptionForLabel: {
        placeholder: "Enter Header Label",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], [{ align: [] }], ["clean"]]
        }
      },
      editorOptionForValue: {
        placeholder: "Enter value",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], [{ align: [] }], ["clean"]]
        }
      },
      editorOptionForQuestion: {
        placeholder: "Enter question",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], [{ align: [] }], ["clean"]]
        }
      },
      editorOptionForInstruction: {
        placeholder: "Enter screen title",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], [{ align: [] }], ["clean"]]
        }
      },
      editorOptionForimageCaptureTitle: {
        placeholder: "Enter Title",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], [{ align: [] }], ["clean"]]
        }
      },
      editorOptionForimageCaptureScreen: {
        placeholder: "Enter content for this topic",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], [{ align: [] }], ["clean"]]
        }
      },
      notValidMapKey: false,
      notUniqueMapKey: false,
      notValidLimit: false,
      notValidInterval: false,
      notUniqueOptions: false,
      notValidCharLimit: false,
      charLimit80: 80,
      charLimitErrTxt: null,
      useEnglishImageInfoDiv: false,
      languagesString: null,
      errorMsg: null,
      modal: "",
      currentPage: null,
      totalPages: null,
      logos: null,
      selectedTemplateImageIconIndex: null,
      participantActivityTypes: ["dro (device reported outcome)", "pro (patient reported outcome)"],
      completedBy: [
        {
          name: "Call Center",
          value: "CallCenter"
        },
        {
          name: "Home Health",
          value: "HomeHealth"
        },
        {
          name: "Observer/Caregiver",
          value: "Observer/Caregiver"
        },
        {
          name: "Patient/Participant",
          value: "Patient/Participant"
        },
        {
          name: "Principal Investigator",
          value: "Principal Investigator"
        },
        {
          name: "Rater",
          value: "Rater"
        },
        {
          name: "Site",
          value: "Site"
        },
        {
          name: "Study Coordinator",
          value: "Study Coordinator"
        },
        {
          name: "Sub-Investigator",
          value: "Sub-Investigator"
        }
      ],
      selectedTemplateImageIcon: "",
      keyToUpdateActivityEditComponent: Date.now(),
      questionTypesvalidationcheck: [
        { value: "SurveyInstruction", validatetype: [] },
        { value: "CustomScale", validatetype: [] },
        { value: "DateTime", validatetype: ["LESS_THAN", "GREATER_THAN"] },
        { value: "DropDown", validatetype: [] },
        { value: "GPSkin", validatetype: [] },
        { value: "ImageCapture", validatetype: [] },
        { value: "Image", validatetype: [] },
        { value: "Index", validatetype: [] },
        { value: "Log", validatetype: [] },
        {
          value: "Measurements",
          validatetype: ["DATA_FORMAT", "LESS_THAN", "GREATER_THAN"],
          dataValidationType: ["Numeric", "DECIMAL"]
        },
        { value: "MedicationSelector", validatetype: [] },
        { value: "MultiChoice", validatetype: [] },
        {
          value: "Number",
          validatetype: ["DATA_FORMAT"],
          dataValidationType: ["Numeric"]
        },
        { value: "NumberScale", validatetype: [] },
        {
          value: "Text",
          validatetype: ["NOT_BLANK", "DATA_TYPE"],
          dataValidationType: ["Numeric", "Alphabet", "Alphanumeric"]
        },
        { value: "ValidatedEntry", validatetype: [] },
        { value: "VAS", validatetype: [] },
        { value: "Boolean", validatetype: [] },
        { value: "WongBaker", validatetype: [] },
        { value: "AudioRecording", validatetype: [] },
        { value: "VideoRecording", validatetype: [] }
      ],
      autoSaveElementTimeout: process.env.VUE_APP_AUTO_SAVE_ELEMENT_LIB_TIMEOUT,
      dataFormatValue: 0,
      dataFormatLastValue: 0,
      dataFormatValidation: {
        min: 1,
        max: 10,
        decimal: 10
      },
      BranchingHelper: new BranchingHelper(),
      groupTags:[
      ],
      selectedOptionIds:[],
      emptyDataHTML: '<span>No tags found. <br> Click “Add” to create new group tag.</span>',
      disableSaveBtn: false
    };
  },
  props: ["options", "activityData", "isQuestionInEditMode", "addQuestion"],
  computed: {
    questionSaveUpdateChanged() {
      return this.$store.getters.getNewActivityQuestion;
    },
    activityDetailsChanged() {
      return this.$store.getters.getActivityDetails;
    },
    questionInputTypes() {
      const activityType = this.activityData.type.toLowerCase();

      if (activityType === "survey" || activityType === "task") {
        if (this.activityData && this.activityData.completedBy && this.activityData.completedBy.length > 0) {
          if (this.activityData.completedBy.includes("Observer/Caregiver") || this.activityData.completedBy.includes("Patient/Participant")) {
            return _.filter(this.questionTypes, type => {
              return type.facingType === "participant" || type.facingType === "both";
            });
          } else {
            return _.filter(this.questionTypes, type => {
              return type.facingType === "site" || type.facingType === "both";
            });
          }
        }
      }

      const facingType = this.participantActivityTypes.indexOf(activityType) >= 0 ? "participant" : "site";

      return _.filter(this.questionTypes, type => {
        return type.facingType === facingType || type.facingType === "both";
      });
    },
    showScoreWhenSkipped() {
      if (this.activityData.canScoreResponses && this.addEditQuestion.isSkippable) {
        if (this.addEditQuestion.type.toLowerCase() === "skinanalyser") {
          return false;
        } else {
          return true;
        }
      }
      return false;
    }
  },
  watch: {
    activityDetailsChanged: {
      handler(val) {
        this.activityDetails = val;
        this.showDataCheckDropdown = false;
      }
    },
    configureDataCheck: {
      handler(val) {
        val.forEach(dataCheck => {
          if (dataCheck.type == "NOT_BLANK") {
            this.$set(dataCheck, "value", "");
          }
        });
      },
      deep: true
    },
    addEditQuestion: {
      handler(val) {
        if(!val.characterLimited) {
          delete val.textLimit;
        }
        if(val.type.toLowerCase() === "text" || val.type.toLowerCase() === "number") {
          if (!val.hasMinMax) {
            val.maxValue = null
            val.minValue = null
          }
        }
        if(!val.hasUnits) {
          val.units = null;
        }
        if(!val.hasSoftMinMax) {
          val.softminValue = null;
          val.softmaxValue = null;
        }
        if(!val.hasAnswerlabelunits) {
          val.answerlabelunits = '';
        }
        this.addEditQuestion = val;
      },
      deep:true
    }
  },
  mounted() {
    this.qlVideoUpload = new QlVideoUploadService(MODULE_NAME, this.$route.params.studyId, localStorage.getItem("clientId"));
    this.options.reasons = [];
    this.options.dosageUnits = [];
    this.options.otherReason = false;
    if (this.addQuestion) {
      this.options.allowImageCollection = false;
    } else {
      if (this.options.allowImageCollection == "undefined" || this.options.allowImageCollection == null) {
        this.options.allowImageCollection = true;
      }
    }
    this.setDataEditChecks();
    if (!this.addEditQuestion.id) {
      this.$set(this.addEditQuestion, "hasPreviousResponses", true);
    } else {
      this.$set(this.addEditQuestion, "hasPreviousResponses", this.addEditQuestion.hasPreviousResponses);
    }
    this.getActivityTypes();
    this.activityId = this.$route.params.activityId;
    this.activityDetails = this.$store.getters.getActivityDetails;

    //Remove custom completion from questionTypes dropdown if the Activity type is not eligible
    if (this.activityData.type != "Survey" && this.activityData.type != "Task" && this.activityData.type != "DRO (Device Reported Outcome)" && this.activityData.type != "PRO (Patient Reported Outcome)") {
      this.questionTypes = this.questionTypes.filter(question => question.value != "SurveyCompletion");
    }

    if (this.activityDetails && this.activityDetails.hasOwnProperty("watchEnabled") && this.activityDetails.watchEnabled) {
      const that = this;
      let localArray = that.questionTypes;
      const itemToRemove = ["CustomScale", "Image", "NumberScale", "Number"];
      that.questionTypes.forEach(function(item) {
        if (itemToRemove.includes(item.value)) {
          localArray = localArray.filter(val => val.value != item.value);
        }
      });
      that.questionTypes = localArray;
    }

    this.allQuestions = this.activityDetails && this.activityDetails.questions ? this.activityDetails.questions : [];
    // this.allQuestions = _.filter(this.allQuestions, o => o.type !== 'SurveyInstruction');
    if (this.addEditQuestion && this.addEditQuestion.options) {
      _.forEach(this.addEditQuestion.options, value => {
        if (!value.nextQuestion) {
          value.nextQuestion = null;
        }
      });
    }
    this.questionTypeChanged(this.addEditQuestion);
    if (this.options) {
      this.options.type = this.options.type ? this.options.type : "Default";
    }
    this.getLogosFromLibrary(1);
    if (typeof this.autoSaveTimer === "undefined") {
      this.startAutoSave();
    }
    this.$root.$on('addSectionFailed',data=>{       
      this.disableSaveBtn = false;    
    });
  },
  filters: {
    removeSpecialCharacters: function(stringOld) {
      let string = stringOld;
      string = string.replace(/[^a-zA-Z ]/g, " ");
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    }
  },
  methods: {
    setDataEditChecks() {
      if (this.options.hasOwnProperty("dataEditChecks") && this.options.hasOwnProperty("isDataCheckConfigured")) {
        this.editFlag = true;
        this.currentQuestionType = this.options.type;
        if (this.options.isDataCheckConfigured) {
          this.configureDataCheck =
            this.options.dataEditChecks.length > 0
              ? this.options.dataEditChecks
              : this.configureDataCheck.push({
                  check: "",
                  type: "",
                  value: "",
                  hasError: false,
                  showDataCheckTypeDropdown: false,
                  id: uuidv4(),
                  dateValue: "",
                  timeValue: ""
                });
          if (this.options.dataEditChecks.length >= 0) {
            this.showDataCheckDropdown = true;
          }
          let i;
          for (i = 0; i < this.options.dataEditChecks.length; i++) {
            if (this.configureDataCheck[i].timeValue != "") {
              if (this.addEditQuestion.timeFormat == "12") {
                this.configureDataCheck[i].timeValue = moment(this.configureDataCheck[i].timeValue, "HH:mm").format("hh:mm A");
              }
            }
            if (this.options.dataEditChecks[i].check == "SOFT") {
              this.currentSoftDataChecks.push(this.options.dataEditChecks[i].type);
            } else {
              this.currentHardDataChecks.push(this.options.dataEditChecks[i].type);
            }
          }
          if (this.options.hasOwnProperty("hasMinMax") && (this.options.hasMinMax == true || this.options.hasSoftMinMax == true)) {
            if (!this.currentSoftDataChecks.some(datacheck => datacheck == "GREATER_THAN")) {
              this.currentSoftDataChecks.push("GREATER_THAN");
            }
            if (!this.currentSoftDataChecks.some(datacheck => datacheck == "LESS_THAN")) {
              this.currentSoftDataChecks.push("LESS_THAN");
            }

            if (!this.currentHardDataChecks.some(datacheck => datacheck == "GREATER_THAN")) {
              this.currentHardDataChecks.push("GREATER_THAN");
            }
            if (!this.currentHardDataChecks.some(datacheck => datacheck == "LESS_THAN")) {
              this.currentHardDataChecks.push("LESS_THAN");
            }
          }
        }
      } else {
        this.editFlag = false;
        this.configureDataCheck.push({
          check: "",
          type: "",
          value: "",
          hasError: false,
          showDataCheckTypeDropdown: false,
          id: uuidv4(),
          dateValue: "",
          timeValue: ""
        });
      }
    },
    showCheckType() {
      this.showDataCheckDropdown = !this.showDataCheckDropdown;
    },

    insertGreaterLessEqual() {
      if (!this.currentSoftDataChecks.some(datacheck => datacheck == "GREATER_THAN")) {
        this.currentSoftDataChecks.push("GREATER_THAN");
      }
      if (!this.currentSoftDataChecks.some(datacheck => datacheck == "LESS_THAN")) {
        this.currentSoftDataChecks.push("LESS_THAN");
      }

      if (!this.currentHardDataChecks.some(datacheck => datacheck == "GREATER_THAN")) {
        this.currentHardDataChecks.push("GREATER_THAN");
      }
      if (!this.currentHardDataChecks.some(datacheck => datacheck == "LESS_THAN")) {
        this.currentHardDataChecks.push("LESS_THAN");
      }
    },
    deleteGreaterLessEqual() {
      this.$delete(this.currentSoftDataChecks, this.currentSoftDataChecks.indexOf("LESS_THAN"));
      this.$delete(this.currentHardDataChecks, this.currentHardDataChecks.indexOf("LESS_THAN"));

      this.$delete(this.currentSoftDataChecks, this.currentSoftDataChecks.indexOf("GREATER_THAN"));
      this.$delete(this.currentHardDataChecks, this.currentHardDataChecks.indexOf("GREATER_THAN"));
    },

    changeValidation(type, event) {
      if (type == "HARDMINMAX" || type == "SOFTMINMAX") {
        if (type == "SOFTMINMAX" && this.addEditQuestion.hasMinMax == true) {
          this.addEditQuestion.hasMinMax = false;
          this.deleteGreaterLessEqual();
        } else if (type == "HARDMINMAX" && this.addEditQuestion.hasSoftMinMax == true) {
          this.addEditQuestion.hasSoftMinMax = false;
          this.deleteGreaterLessEqual();
        }

        if (event.target.checked == true) {
          if (this.addEditQuestion.isDataCheckConfigured == true) {
            if (this.configureDataCheck.some(datacheck => datacheck.type == "GREATER_THAN" || datacheck.type == "LESS_THAN" || datacheck.type == "EQUAL_TO")) {
              type == "SOFTMINMAX" ? (this.addEditQuestion.hasSoftMinMax = false) : (this.addEditQuestion.hasMinMax = false);
              this.$toastr.error("Please remove checks from configurator first.");
              return false;
            } else if (this.configureDataCheck.some(datacheck => datacheck.type == "GREATER_THAN" || datacheck.type == "LESS_THAN" || datacheck.type == "EQUAL_TO")) {
              type == "SOFTMINMAX" ? (this.addEditQuestion.hasSoftMinMax = false) : (this.addEditQuestion.hasMinMax = false);
              this.$toastr.error("Please remove checks from configurator first.");
              return false;
            }
          }

          this.insertGreaterLessEqual();
        } else {
          this.deleteGreaterLessEqual();
        }
      } else if (type == "DECIMAL") {
        if (this.addEditQuestion.decimalValue) {
          this.addEditQuestion.decimalValue = null;
        }
        if (this.configureDataCheck.some(datacheck => datacheck["value"] == "Numeric")) {
          this.addEditQuestion.allowDecimals = false;
          this.$toastr.error("Please remove Numeric data type from configurator first.");
          return false;
        }
      } else if (type == "DATACHECK") {
        if (event.target.checked == true) {
          this.isDataCheckConfigured = true;
        } else {
          this.clearDataCheck();
          this.editFlag = false;
          if (this.addEditQuestion.hasSoftMinMax == false && this.addEditQuestion.hasMinMax == false) {
            this.currentSoftDataChecks = [];
            this.currentHardDataChecks = [];
          } else {
            this.$delete(this.currentSoftDataChecks, this.currentSoftDataChecks.indexOf("NOT_BLANK"));
            this.$delete(this.currentHardDataChecks, this.currentHardDataChecks.indexOf("NOT_BLANK"));

            this.$delete(this.currentSoftDataChecks, this.currentSoftDataChecks.indexOf("DATA_TYPE"));
            this.$delete(this.currentHardDataChecks, this.currentHardDataChecks.indexOf("DATA_TYPE"));
          }
        }
      }
    },
    addDataCheck(index) {
      this.editFlag = false;
      this.configureDataCheck[index]["hasError"] = false;

      if (this.configureDataCheck[index]["type"] == "LESS_THAN" || this.configureDataCheck[index]["type"] == "GREATER_THAN" || this.configureDataCheck[index]["type"] == "EQUAL_TO") {
        if (this.addEditQuestion.hasMinMax == true || this.addEditQuestion.hasSoftMinMax == true) {
          if (!this.currentSoftDataChecks.some(datacheck => datacheck == this.configureDataCheck[index]["type"])) {
            this.currentSoftDataChecks.push(this.configureDataCheck[index]["type"]);
          }

          if (!this.currentHardDataChecks.some(datacheck => datacheck == this.configureDataCheck[index]["type"])) {
            this.currentHardDataChecks.push(this.configureDataCheck[index]["type"]);
          }

          return toastr.error("Only one data check is allowed for this activity, and it already exists.");
        }
      }
      this.showDataCheckDropdown = true;
    },
    updateDataChecks() {
      const addSoftDataCheck = this.configureDataCheck.filter(datacheck => datacheck.check == "SOFT").map(datacheck => datacheck.type);

      this.currentSoftDataChecks = addSoftDataCheck;

      const addHardDataCheck = this.configureDataCheck.filter(datacheck => datacheck.check == "HARD").map(datacheck => datacheck.type);

      this.currentHardDataChecks = addHardDataCheck;
      if (this.addEditQuestion.type == "Measurements") {
        if (!this.currentHardDataChecks.some(datacheck => datacheck == "GREATER_THAN")) {
          this.currentHardDataChecks.push("GREATER_THAN");
        }
        if (!this.currentHardDataChecks.some(datacheck => datacheck == "LESS_THAN")) {
          this.currentHardDataChecks.push("LESS_THAN");
        }
      }
    },

    addAnotherDataCheck(index) {
      let errorObj = {};
      errorObj = this.dataCheckConfiguredValidation(this.configureDataCheck);
      if (errorObj) {
        this.configureDataCheck.push({
          check: "",
          type: "",
          value: "",
          hasError: false,
          showDataCheckTypeDropdown: false,
          id: uuidv4(),
          dateValue: "",
          timeValue: ""
        });

        if (this.configureDataCheck.length > 0) {
          this.addDataCheck(index);
        }
      } else {
        this.$toastr.error("Please select all required values");
      }
    },
    removeDataCheck(index) {
      if (this.configureDataCheck[index]["check"] == "SOFT") {
        this.$delete(this.currentSoftDataChecks, this.currentSoftDataChecks.indexOf(this.configureDataCheck[index]["type"]));
      } else {
        this.$delete(this.currentHardDataChecks, this.currentHardDataChecks.indexOf(this.configureDataCheck[index]["type"]));
      }

      if (!this.configureDataCheck[index]["type"] == "LESS_THAN" || this.configureDataCheck[index]["type"] == "GREATER_THAN" || this.configureDataCheck[index]["type"] == "EQUAL_TO") {
        this.addEditQuestion.hasMinMax = false;
      }
      this.configureDataCheck.splice(index, 1);
    },
    getActivityTypes() {
      this.$api
        .getActivityTypes()
        .then(response => {
          this.activityTypes = response.data.result;
        })
        .catch(() => {
          this.$toastr.error("Error in getting Therapeutic Areas");
        });
    },
    dateRangeChanged() {
      this.$forceUpdate();
    },
    timeRangeChanged() {
      this.$forceUpdate();
    },
    setTwoNumberDecimal() {
      this.addEditQuestion.weight = parseFloat(this.addEditQuestion.weight).toFixed(1);
    },
    setDateSelection(event) {
      if (event.target.checked && event.target.checked == true) {
        if (!this.addEditQuestion.dateFormat) {
          this.addEditQuestion.dateFormat = "mm/dd/yyyy";
        }
      }
    },
    setTimeSelection(event) {
      if (event.target.checked && event.target.checked == true) {
        if (!this.addEditQuestion.timeFormat) {
        }
      }
      // this.addEditQuestion.timeFormat = "12";
    },
    setTimeRangeSelection(event) {
      this.$nextTick(() => {
        if (event.target.checked && event.target.checked == true) {
          this.addEditQuestion.timeRange = 0;
        } else {
          this.addEditQuestion.timeRange = 1;
          if (this.addEditQuestion.startTime) {
            this.addEditQuestion.startTime = "";
          }
          if (this.addEditQuestion.endTime) {
            this.addEditQuestion.endTime = "";
          }
          if (this.addEditQuestion.hoursBefore) {
            this.addEditQuestion.hoursBefore = null;
          }
          if (this.addEditQuestion.hoursAfter) {
            this.addEditQuestion.hoursAfter = null;
          }
        }
      });
    },
    setDateRangeSelection(event) {
      this.$nextTick(() => {
        if (event.target.checked && event.target.checked == true) {
          this.addEditQuestion.dateRange = 0;
        } else {
          this.addEditQuestion.dateRange = 1;
          if (this.addEditQuestion.startDate) {
            this.addEditQuestion.startDate = "";
          }
          if (this.addEditQuestion.endDate) {
            this.addEditQuestion.endDate = "";
          }
          if (this.addEditQuestion.daysAfter) {
            this.addEditQuestion.daysAfter = null;
          }
          if (this.addEditQuestion.daysBefore) {
            this.addEditQuestion.daysBefore = null;
          }
          if (this.addEditQuestion.useEndCurrentDate) {
            this.addEditQuestion.useEndCurrentDate = false;
          }
          if (this.addEditQuestion.useStartCurrentDate) {
            this.addEditQuestion.useStartCurrentDate = false;
          }
          if (this.addEditQuestion.useTargetCurrentDate) {
            this.addEditQuestion.useTargetCurrentDate = false;
          }
        }
      });
    },
    addImage() {
      const prevTemplateImageId = this.addEditQuestion && this.addEditQuestion.templateImageId ? this.addEditQuestion.templateImageId.substr(0, this.addEditQuestion.templateImageId.lastIndexOf(".")) : "";
      const file = {
        fileName: this.selectedTemplateImageIcon.name,
        contentType: "image/png",
        sequence: this.addEditQuestion && this.addEditQuestion.sequence,
        templateImageId: `template_img_id_${Math.random()
          .toString(36)
          .substr(2, 10)}`,
        previousTemplateImageId: prevTemplateImageId,
        preSignedURL: this.selectedTemplateImageIcon.preSignedURL
      };
      const isInstructionTemplate = true;
      this.$api.imageActivityUploadFact(this.activityDetails.id, file, isInstructionTemplate).then(response => {
        this.addEditQuestion.templateImageUrl = response.body.result.imageUrl;
        this.addEditQuestion.templateImageId = response.body.result.imageId;
      });
      this.modal = "";
      window.$("#myModal").modal("hide");
    },
    cancelImages() {
      this.modal = "";
      window.$("#myModal").modal("hide");
      this.selectedTemplateImageIcon = {};
    },
    selectLogo(page) {
      this.selectedTemplateImageIcon = {};
      this.selectedTemplateImageIcon = page;
    },
    getLogosFromLibrary(pageNumber) {
      this.modal = "logo";
      this.currentPage = pageNumber;
      this.$api.getTemplateLogosFact(pageNumber).then(response => {
        this.logos = response.body.icons;
        this.totalPages = response.body.totalPages;
      });
    },
    hidePopup(popupName) {
      if (popupName == "email") {
        this.infoDiv = false;
      } else if (popupName == "mediReason") {
        this.mediInfoDiv = false;
      }
      this.$el.blur();
    },
    showPopup(popupName) {
      if (popupName == "email") {
        this.infoDiv = true;
      } else if (popupName == "mediReason") {
        this.mediInfoDiv = true;
      }
      this.$el.focus();
    },
    toggleInfoDiv(stepType) {
      if (this.infoDiv && stepType == "email") {
        this.hidePopup(stepType);
      } else if (!this.infoDiv && stepType == "email") {
        this.showPopup(stepType);
      } else if (this.mediInfoDiv && stepType == "mediReason") {
        this.showPopup(stepType);
      } else if (!this.mediInfoDiv && stepType == "mediReason") {
        this.showPopup(stepType);
      }
    },
    hideMapPopup() {
      this.mapinfoDiv = false;
      this.$el.blur();
    },
    showMapPopup() {
      this.mapinfoDiv = true;
      this.$el.focus();
    },
    toggleMapInfoDiv() {
      if (this.mapinfoDiv) {
        this.hideMapPopup();
      } else {
        this.showMapPopup();
      }
    },
    hideWongBakerPopup() {
      this.wongBakerInfoDiv = false;
      this.$refs.tooltipContent.blur();
    },
    showWongBakerPopup() {
      this.wongBakerInfoDiv = true;
      this.$nextTick(function() {
        this.$refs.tooltipContent.focus();
      });
    },
    toggleWongBakerInfoDiv() {
      if (this.wongBakerInfoDiv) {
        this.hideWongBakerPopup();
      } else {
        this.showWongBakerPopup();
      }
    },
    toggleNotifyToEmail(that) {
      // eslint-disable-next-line no-param-reassign
      that = !that;
    },
    questionTypeChanged(addEditQuestion) {
      if (this.addEditQuestion.isDataCheckConfigured && !this.editFlag) {
        this.addEditQuestion.isDataCheckConfigured = false;
      } else {
        this.editFlag = false;
      }
      if (this.currentQuestionType != this.addEditQuestion.type) {
        this.clearDataCheck();
        this.currentSoftDataChecks = [];
        this.currentHardDataChecks = [];
        if (this.addEditQuestion.type === "Measurements") {
          if (!this.currentHardDataChecks.some(datacheck => datacheck == "GREATER_THAN")) {
            this.currentHardDataChecks.push("GREATER_THAN");
          }
          if (!this.currentHardDataChecks.some(datacheck => datacheck == "LESS_THAN")) {
            this.currentHardDataChecks.push("LESS_THAN");
          }
        }
        if (this.addEditQuestion.type === "NumberScale") {
          this.addEditQuestion.formattedLabels = [];
          this.addEditQuestion.labels = [];
        }
      }

      // keeping a check on selection of surveycompletion error if it already exist
      if (this.addQuestion && !this.isQuestionInEditMode) {
        if (addEditQuestion.type == "SurveyCompletion") {
          const getCompletionIndex = this.allQuestions.findIndex(item => item.subtype == "custom");
          if (getCompletionIndex != -1) {
            addEditQuestion.type = "Default";
            return toastr.error("Only one completion screen is allowed for this activity, and it already exists.");
          }
        }
      }

      if (addEditQuestion && addEditQuestion.type) {
        const questionType = addEditQuestion.type.toLowerCase();
        this.keyToUpdateActivityEditComponent = Date.now();
        switch (questionType) {
          case "text":
            this.addEditQuestion.isAdvancedScoring = false;
            this.addEditQuestion.score = 0;
            break;
          case "datetime":
            if (!this.addEditQuestion.id) {
              this.addEditQuestion.showDate = true;
              this.addEditQuestion.showTime = true;
            }
            if (!this.addEditQuestion.dateFormat) {
              this.addEditQuestion.dateFormat = "mm/dd/yyyy";
            }
            if (!this.addEditQuestion.timeFormat) {
              this.addEditQuestion.timeFormat = "12";
            }
            this.addEditQuestion.isAdvancedScoring = false;
            this.$set(this.addEditQuestion, "score", 0);
            break;
          case "boolean":
            if (!this.addEditQuestion.options || this.addEditQuestion.options.length === 0) {
              this.addEditQuestion.options = [
                { body: null, sequence: 1, nextQuestion: null, imageUrl: null },
                { body: null, sequence: 2, nextQuestion: null, imageUrl: null }
              ];
            }
            this.addEditQuestion.options[0].body = "Yes";
            this.addEditQuestion.options[1].body = "No";
            this.addEditQuestion.options[0].formattedBody = "Yes";
            this.addEditQuestion.options[1].formattedBody = "No";
            break;
          case "multichoice":
            if (!this.addEditQuestion.options || this.addEditQuestion.options.length === 0) {
              this.addEditQuestion.options = [
                { body: null, sequence: 1, nextQuestion: null, imageUrl: null },
                { body: null, sequence: 2, nextQuestion: null, imageUrl: null }
              ];
            }
            this.addEditQuestion.options[0].body = this.addEditQuestion.options[0].body || "";
            this.addEditQuestion.options[1].body = this.addEditQuestion.options[1].body || "";
            break;
          case "dropdown":
            if (!this.addEditQuestion.options || this.addEditQuestion.options.length === 0) {
              this.addEditQuestion.options = [
                { body: null, sequence: 1, nextQuestion: null, imageUrl: null },
                { body: null, sequence: 2, nextQuestion: null, imageUrl: null }
              ];
            }
            this.addEditQuestion.options[0].body = this.addEditQuestion.options[0].body || "";
            this.addEditQuestion.options[1].body = this.addEditQuestion.options[1].body || "";
            const questionDropdown = this.addEditQuestion;
            for (let k = 0; k < questionDropdown.options.length; k++) {
              if (questionDropdown.options[k].score == "") {
                questionDropdown.options[k].score = 0;
              }
            }
            break;
          case "numberscale":
            if (!this.addEditQuestion.formattedLabels) {
              this.addEditQuestion.formattedLabels = [];
            }
            break;
          case "customscale":
            if (!this.addEditQuestion.formattedLabels) {
              this.addEditQuestion.formattedLabels = [];
            }
            if (!this.addEditQuestion.scores) {
              this.addEditQuestion.scores = [];
            }
            if (!this.addEditQuestion.excludeScores) {
              this.addEditQuestion.excludeScores = [];
            }
            if (!this.addEditQuestion.operators) {
              this.addEditQuestion.operators = [];
            }
            if (!this.addEditQuestion.stepValues) {
              this.addEditQuestion.stepValues = [];
            }

            this.addEditQuestion.formattedLabels.length = this.addEditQuestion.formattedLabels.length || 5;
            const questionCustomScale = this.addEditQuestion;
            questionCustomScale.scores.forEach(key => {
              if (questionCustomScale.scores[key] == "") {
                this.$set(questionCustomScale.scores, key, 0);
              }
            });
            break;
          case "number":
            this.addEditQuestion.minValue = this.addEditQuestion.id ? this.addEditQuestion.minValue : "";
            this.addEditQuestion.maxValue = this.addEditQuestion.id ? this.addEditQuestion.maxValue : "";
            break;
          case "gpskin":
            if (!this.addEditQuestion.id) {
              this.addEditQuestion.formattedInformation = "<p>You will measure your left forearm three times. </p><p><br></p><p>Click the button once to begin first scan. Quickly place the device on your skin in the position shown above.</p>";
            }
            break;
          case "wongbaker":
            if (!this.addEditQuestion.id) {
              this.addEditQuestion.formattedInformation = "<p>Choose the face* that best depicts the pain that you are experiencing.</p>";
            }
            break;
          case "image":
            // this logic is implemented in image-choice.vue component
            if (!this.addEditQuestion.id) {
              this.$set(this.addEditQuestion, "useEnglishImageAnswer", true);
            } else {
              this.$set(this.addEditQuestion, "useEnglishImageAnswer", this.addEditQuestion.useEnglishImageAnswer);
            }
            break;
          case "imagecapture":
            this.addEditQuestion.formattedInformation = this.addEditQuestion.formattedInformation ? this.addEditQuestion.formattedInformation : null;
            this.addEditQuestion.formattedTitle = this.addEditQuestion.formattedTitle ? this.addEditQuestion.formattedTitle : null;
            break;
          case "vas":
            if (!this.addEditQuestion.id) {
              this.addEditQuestion.isSkippable = false;
            }
            break;
          case "log":
            if (this.addEditQuestion.entries && this.addEditQuestion.entries.length) {
              return;
            } else {
              this.addEditQuestion.entries = [];
            }
            this.addEditQuestion.entries &&
              this.addEditQuestion.entries.push({
                header: null,
                sequence: 1
              });
            break;
          case "measurements":
            if (!this.addEditQuestion.id) {
              this.$set(this.addEditQuestion, "subType", "weight");
              this.$set(this.addEditQuestion, "measurementUnit", "lbs");
              this.addEditQuestion.isSkippable = false;
            }
            break;
          case "validatedentry":
            if (!this.addEditQuestion.id) {
              this.$set(this.question, "fieldType", "email");
              this.$set(this.question, "lettersAllowed", true);
              this.$set(this.question, "numbersAllowed", true);
              this.$set(this.question, "specialCharactersAllowed", true);
              this.$set(this.question, "isAllowUsertoAddAdditional", true);
              this.$set(this.question, "maxChars", 200);
              this.$set(this.question, "maxLimit", 200);
              this.$set(this.question, "minChars", 0);
              this.$set(this.question, "minLimit", 0);
              this.$set(this.question, "numberOfLines", 3);
              this.$set(this.question, "decimalLimit", 2);
            }
            break;
          case "medicationselector":
            if (!this.addEditQuestion.id) {
              this.addEditQuestion.isSkippable = false;
            }
            if (this.addEditQuestion.score == "") {
              this.addEditQuestion.score = 0;
            }
            break;
          default:
            this.addEditQuestion.labels = [];
            if (!this.addEditQuestion.id) {
              this.addEditQuestion.isSkippable = false;
            }
            break;
        }
      }
    },
    stripHtml(content) {
      const temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = content;
      return temporalDivElement.innerText;
    },
    splitPTagfromContent(text) {
      if (text == null) {
        return;
      }
      return text.replace("<p>", "").replace("</p>", "");
    },
    questionTypesTags(question) {
      if (!!question.formattedTitle && question.formattedTitle) {
        question.formattedTitle = this.renderTagsHtml(question.formattedTitle);
      }
      if (!!question.formattedBody && question.formattedBody) {
        question.formattedBody = this.renderTagsHtml(question.formattedBody);
      }
      if (!!question.formattedInformation && question.formattedInformation) {
        question.formattedInformation = this.renderTagsHtml(question.formattedInformation);
      }
    },
    renderTagsHtml(information) {
      if (information) {
        if (information.includes("&amp;nbsp;")) {
          return information.replaceAll("&amp;nbsp;", " ");
        }
        if (information.includes("&nbsp;")) {
          return information.replaceAll("&nbsp;", " ");
        }
        return information;
      }
    },
    iterateQuestionForFormattedText(question) {
      if (question.type == "SurveyInstruction" || question.type == "GPSkin" || question.type == "ImageCapture" || question.type == "VideoRecording" || question.type == "AudioRecording" || question.type == "WongBaker" || question.type == "SkinAnalyser") {
        question.title = _.isUndefined(question.formattedTitle) ? "" : this.stripHtml(question.formattedTitle);
        question.information = _.isUndefined(question.formattedInformation) ? "" : this.stripHtml(question.formattedInformation);
        question.formattedTitle = activityService.replaceContinuousSpacesWithTags(question.formattedTitle);
        question.formattedInformation = activityService.replaceContinuousSpacesWithTags(question.formattedInformation);
        question.formattedBody = question.formattedTitle;
        question.body = _.isUndefined(question.formattedBody) ? "" : this.stripHtml(question.formattedBody);
      } else if (question.type == "CustomScale") {
        question.labels = [];
        question.body = this.stripHtml(question.formattedBody);
        question.formattedLabels.map((element, index) => {
          question.formattedLabels[index] = this.splitPTagfromContent(element);
          question.labels.push(this.stripHtml(element));
        });
      } else {
        question.body = this.stripHtml(question.formattedBody);
        if (question.options == undefined || question.options.length == 0) {
          return;
        }
        for (let i = 0; i < question.options.length; i++) {
          question.options[i].body = this.stripHtml(question.options[i].formattedBody);
          question.options[i].formattedBody = this.splitPTagfromContent(question.options[i].formattedBody);
        }
      }
    },
    checkForCustomMessage(question) {
      const mutipleMessage = ["dropdown", "multichoice"];
      if (mutipleMessage.indexOf(question.type.toLowerCase()) < 0 && !!question.isAddMessageEnabled === false && !!question.messageBody) {
        question.messageBody = "";
        return;
      }

      if (mutipleMessage.indexOf(question.type.toLowerCase()) >= 0) {
        question.options.forEach(val => {
          if (!!val.isAddMessageEnabled === false && !!val.messageBody) {
            val.messageBody = "";
          }
        });
        return;
      }
    },
    checkSectionValidity(question) {
      let questionTitle = question.title.trim()
      if (questionTitle.length > 150) {
        let isValid = false;
        let msg = "Title cannot exceed 150 characters.";
        let errorObj = { isValid, msg };
        this.disableSaveBtn = false;
        return errorObj;
      }

      // Title should not be empty
      if (!questionTitle) {
        let isValid = false;
        let msg = "Section Title is required.";
        let errorObj = { isValid, msg };
        this.disableSaveBtn = false;
        return errorObj;
      }
      let questionWithSameTitle = this.activityData.questions.find( (q) => {
        if(!!q.title && q.type === 'Section'){
          return q.title.trim() === questionTitle;
        }
      });
      if (questionWithSameTitle) {
        if (questionWithSameTitle.id !== question.id) {
          let isValid = false;
          let msg = "Please provide unique section name";
          let errorObj = { isValid, msg };
          this.disableSaveBtn = false;
          return errorObj;
        }
      }
      return { isValid: true };
    },
    dataCheckConfiguredValidation(data) {
      let isEmpty = false;
      let lessThan = "";
      let greaterThan = "";
      let isDataFormatValue = false;

      data.forEach(element => {
        if (!element.check) {
          isEmpty = true;
        }
        element.value = element.value.trim();
        if (this.addEditQuestion.type == "DateTime") {
          if (element.dateValue != "" && element.timeValue != "" && this.addEditQuestion.showDate && this.addEditQuestion.showTime) {
            element.dateValue = this.$moment.utc(element.dateValue).format("YYYY-MM-DD");
            element.timeValue = moment(element.timeValue, "hh:mm A").format("HH:mm");
            element.value = element.dateValue + "T" + element.timeValue + ":00.000Z";
          } else if (element.dateValue != "" && this.addEditQuestion.showDate) {
            element.dateValue = this.$moment.utc(element.dateValue).format("YYYY-MM-DD");
            element.value = element.dateValue + "T00:00:00.000Z";
          } else if (element.timeValue != "" && this.addEditQuestion.showTime) {
            element.value = element.timeValue;
          }
        }
        if (element.type == "" || (element.value == "" && element.type != "NOT_BLANK")) {
          if (element.check != "" && element.type != "DATA_FORMAT") {
            element.hasError = true;
            isEmpty = true;
          }
        } else {
          element.hasError = false;
        }
        if (element.type == "LESS_THAN" && element.check == "HARD" && element.value == "") {
          lessThan = element.value;
        }
        if (element.type == "GREATER_THAN" && element.check == "HARD" && element.value == "") {
          greaterThan = element.value;
        }

        if (element.type == "DATA_FORMAT" && (element.value == "" || element.value < 1)) {
          isDataFormatValue = true;
        }
      });
      if (isEmpty) {
        this.$toastr.error("Please select all required values");
        return false;
      } else if (lessThan != "" && greaterThan != "" && lessThan < greaterThan) {
        this.$toastr.error("Greater than value can not be larger than Less than value");
        return false;
      } else if (isDataFormatValue) {
        this.$toastr.error("Please enter value greater than or equal to 1");
        return false;
      } else {
        return true;
      }
    },
    async saveQuestion(autoSave=false) {
      this.disableSaveBtn = true;
      if (!autoSave) {
        this.addEditQuestion.videoId = this.qlVideoUpload.getVideoIdsFromIframeTagIds(this.addEditQuestion);
      }
      this.questionTypesTags(this.addEditQuestion);
      if (this.addEditQuestion.type && this.addEditQuestion.type.toLowerCase() === "vas" && this.addEditQuestion.isScaleType) {
        this.addEditQuestion.scaleDisplayType = "VAS";
      }
      if (this.addEditQuestion.type == "CustomScale") {
        if (this.addEditQuestion.hasOwnProperty("defaultPointerPosition") && (this.addEditQuestion.defaultPointerPosition === "min" || this.addEditQuestion.defaultPointerPosition === "max")) {
          delete this.addEditQuestion["defaultPointerPosition"];
        } else if (!this.addEditQuestion.hasOwnProperty("defaultPointerPosition")) {
          delete this.addEditQuestion["defaultPointerPosition"];
        } else if (this.addEditQuestion.hasOwnProperty("verticalScale") && this.addEditQuestion.verticalScale && this.addEditQuestion.type == "CustomScale" && (this.addEditQuestion.defaultPointerPosition === "left" || this.addEditQuestion.defaultPointerPosition === "right")) {
          delete this.addEditQuestion["defaultPointerPosition"];
        } else if (this.addEditQuestion.hasOwnProperty("verticalScale") && !this.addEditQuestion.verticalScale && this.addEditQuestion.type == "CustomScale" && (this.addEditQuestion.defaultPointerPosition === "top" || this.addEditQuestion.defaultPointerPosition === "bottom")) {
          delete this.addEditQuestion["defaultPointerPosition"];
        } else if (this.addEditQuestion.defaultPointerPosition === undefined || this.addEditQuestion.defaultPointerPosition === "" || this.addEditQuestion.defaultPointerPosition === null) {
          delete this.addEditQuestion["defaultPointerPosition"];
        }
        this.addEditQuestion.branchingOptions = [];
        this.iterateQuestionForFormattedText(this.addEditQuestion);
      }
      if (this.addEditQuestion.type === "NumberScale") {
        if (this.addEditQuestion.hasOwnProperty("defaultPointerPosition") && (this.addEditQuestion.defaultPointerPosition === "top" || this.addEditQuestion.defaultPointerPosition === "bottom" || this.addEditQuestion.defaultPointerPosition === "middle" || this.addEditQuestion.defaultPointerPosition === "left" || this.addEditQuestion.defaultPointerPosition === "right")) {
          delete this.addEditQuestion["defaultPointerPosition"];
        } else if (!this.addEditQuestion.hasOwnProperty("defaultPointerPosition")) {
          delete this.addEditQuestion["defaultPointerPosition"];
        } else if (this.addEditQuestion.defaultPointerPosition === undefined || this.addEditQuestion.defaultPointerPosition === "" || this.addEditQuestion.defaultPointerPosition === null) {
          delete this.addEditQuestion["defaultPointerPosition"];
        }
      }
      if (this.addEditQuestion && this.addEditQuestion.branchingConfigured && this.addEditQuestion.type == "MultiChoice" && this.addEditQuestion.subType == "Single") {
        this.addEditQuestion.branchingType = "normal";
        this.addEditQuestion.recursiveBranching = false;
        this.addEditQuestion.recursiveLoopEndQuestionId = null;
      }
      if (!this.addEditQuestion.isDataCheckConfigured) {
        this.addEditQuestion.isDataCheckConfigured = false;
      }
      if (this.addEditQuestion.isDataCheckConfigured == true) {
        const isValidDataCheck = this.dataCheckConfiguredValidation(this.configureDataCheck);

        if (!isValidDataCheck) {
          return false;
        }

        let hardFlag = false;
        for (let k = 0; k < this.configureDataCheck.length; k++) {
          if (this.configureDataCheck[k].type == "DATA_FORMAT" && this.addEditQuestion.type == "Number") {
            if (this.configureDataCheck[k].value.indexOf(".") > -1 && !this.addEditQuestion.allowDecimals) {
              toastr.error("Please enable allow decimal to continue.");
              return false;
            }
          }

          if (this.configureDataCheck[k].type == "DATA_FORMAT" && this.addEditQuestion.type == "Measurements" && this.addEditQuestion.subType == "measurements") {
            if (this.configureDataCheck[k].value.indexOf(".") > -1 && !this.addEditQuestion.isDecimalField) {
              toastr.error("Please enable decimal places to continue.");
              return false;
            }
          }
          if (this.configureDataCheck[k].check == "SOFT") {
            if (!hardFlag) {
              this.addEditQuestion.isSkippable = true;
            }
          } else {
            hardFlag = true;
            this.addEditQuestion.isSkippable = false;
          }
        }
        this.addEditQuestion.dataEditChecks = this.configureDataCheck;
      }

      let errorObj = {};
      const ref = this.$refs.activityStepsEdit;

      if (ref) {
        if (this.addEditQuestion.type == "GPSkin") {
          errorObj = ref.checkQuestionValidity();
        }
        if (typeof ref.checkQuestionValidity === "function") {
          errorObj = ref.checkQuestionValidity();
        }
      }
      if (this.addEditQuestion.type == "Section") {
        errorObj = this.checkSectionValidity(this.addEditQuestion);
        let sectionObj = this.getOldSectionTitle(this.addEditQuestion.id);
        let sectionTitle = !!sectionObj ? sectionObj : this.addEditQuestion.title;
        let isSectionUsedInFormula = await this.getFilteredVariableList(sectionTitle);
        if(isSectionUsedInFormula && this.addEditQuestion.id){
          this.showAdvancedScoringWarning(sectionTitle);
          return;
        }
      }

      if (typeof errorObj !== "object") {
        errorObj = { isValid: false, msg: "Step is required" };
      }
      let validQuestion = Boolean(errorObj && errorObj.isValid);

      /* Data Map Key Validation for all question type START */
      if (this.addEditQuestion.isDataMapped) {
        if (this.notUniqueMapKey || this.notValidMapKey || this.addEditQuestion.mapLabel === undefined || this.addEditQuestion.mapLabel === "") {
          validQuestion = false;
          if (this.notUniqueMapKey) {
            if (!autoSave) {
              toastr.error("This Field Name already exists. Enter a unique name.");
            }
          } else {
            if (!autoSave) {
              toastr.error("Map Data field name is required.");
            }
          }
          return false;
        } else {
          this.addEditQuestion.mapLabel = this.addEditQuestion.mapLabel.trim();
        }
      }
      /* Data Map Key Validation for all question type END */

      if (validQuestion != null && typeof validQuestion === "object") {
        if (!autoSave) {
          toastr.error(validQuestion.message);
        }
        return;
      }
      if (validQuestion) {
        let parts = "";
        if (this.addEditQuestion.type === "NumberScale") {
          this.addEditQuestion.branchingOptions = [];
          parts = (this.addEditQuestion.maxValue - this.addEditQuestion.minValue) / this.addEditQuestion.intervals;
          if (Number.isInteger(parts)) {
            this.addEditQuestion.partitions = parts;
          } else {
            this.addEditQuestion.partitions = 1;
          }
        } else if (this.addEditQuestion.type === "Image") {
          delete this.addEditQuestion.options;
        } else if (this.addEditQuestion.type === "Log") {
          this.addEditQuestion.entries = this.addEditQuestion.entries.map(function(entry) {
            return { header: entry.header, label: entry.label };
          });
        }
        if (this.addEditQuestion.type == "ImageCapture" && this.addEditQuestion.guideParticipant == false) {
          this.addEditQuestion.templateImageUrl = "";
          this.addEditQuestion.templateImageId = "";
        }
        if (this.addEditQuestion.type === "Section") {
          this.addEditQuestion.branchingConfigured = false;
        }
        if (this.addEditQuestion.type.toLowerCase() === "multichoice" && this.addEditQuestion.multipleSelection) {
          this.addEditQuestion.options.forEach(option => (option.priority = 0));
        }
        if (this.addEditQuestion.type.toLowerCase() === "dropdown" && this.addEditQuestion.multipleSelection) {
          this.addEditQuestion.options.forEach(option => (option.priority = 0));
        }
        this.iterateQuestionForFormattedText(this.addEditQuestion);
        if (this.activityData.customParticipantMessaging) {
          this.checkForCustomMessage(this.addEditQuestion);
        }
        this.addEditQuestion.autoSave = autoSave;
        if (!autoSave) {
          if (this.BranchingHelper.isConfigurationValidForBranching(this.addEditQuestion)) {
            this.$store.dispatch("addActivityQuestionAction", this.addEditQuestion);
          } else {
            this.alertInvalidConfig();
          }
        } else {
          this.$store.dispatch("addActivityQuestionAction", {
            ...this.addEditQuestion
          });
        }
        this.notValidLimit = false;
        this.notValidInterval = false;
        this.notUniqueOptions = false;
      } else {
        if (!autoSave) {
          this.$toastr.error(errorObj.msg || "Step is required");
        }
      }
    },
    alertInvalidConfig() {
      swal({
        title: `Existing branching configurations are invalid with this change.<br />How would you like to continue?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#4c8ce4",
        confirmButtonText: "Save and Remove Branching",
        cancelButtonText: "Cancel",
        reverseButtons: true,
        customClass: "custom-cancel"
      }).then(({ value }) => {
        if (value) {
          //confirmed
          this.addEditQuestion = this.BranchingHelper.removeBranching(this.addEditQuestion);
          this.$store.dispatch("addActivityQuestionAction", this.addEditQuestion);
        }
      });
    },
    // TODO change this on submittting the form
    validateCharacterLimit(obj, data) {
      this.notValidLimit = false;
      if (obj.type.toLowerCase() === "number" && data > 15) {
        toastr.error("Character limit cannot exceed 15.");
      } else if (obj.type.toLowerCase() === "text" && data > 512) {
        toastr.error("Character limit cannot exceed 512.");
      }
    },
    validateMapLabelOnChange(event, questionId, autoSave = false) {
      this.$validator.validateAll().then(() => {
        const formArray = _.filter(this.activityData.questions, o => o.id != questionId && o.isDataMapped && o.isDataMapped);
        const fieldNames = _.map(formArray, "mapLabel");
        if (event.target.value === "") {
          swal({
            title: `Are you sure you want to delete the data mapping field?`,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#b8c7ce",
            cancelButtonColor: "#f16559",
            confirmButtonText: "Cancel",
            cancelButtonText: "Delete"
          }).then(({ dismiss }) => {
            if (dismiss === "cancel") {
              this.addEditQuestion.isDataMapped = false;
              this.notValidMapKey = false;
            } else {
              this.addEditQuestion.isDataMapped = true;
            }
          });
          this.notValidMapKey = true;
          this.notUniqueMapKey = false;
        } else if (_.compact(_.uniq(fieldNames)).length === _.compact(fieldNames).length && _.compact(_.uniq(fieldNames)).indexOf(event.target.value.trim()) > -1) {
          if (!autoSave) {
            toastr.error("This Field Name already exists. Enter a unique name.");
          }
          this.notValidMapKey = true;
          this.notUniqueMapKey = true;
        } else {
          this.notUniqueMapKey = false;
          this.notValidMapKey = false;
        }
      });
    },
    removeDataMapKey(event) {
      if (!event.target.checked && this.addEditQuestion.mapLabel !== undefined && this.addEditQuestion.mapLabel !== "") {
        swal({
          title: `Are you sure you want to delete the data mapping field "${this.addEditQuestion.mapLabel}"?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#b8c7ce",
          cancelButtonColor: "#f16559",
          confirmButtonText: "Cancel",
          cancelButtonText: "Delete"
        }).then(({ dismiss }) => {
          if (dismiss === "cancel") {
            this.addEditQuestion.mapLabel = "";
          } else {
            this.addEditQuestion.isDataMapped = true;
          }
        });
      }

      if (event.target.checked === false) {
        this.notValidMapKey = false;
      }
    },
    cancelQuestion() {
      if (this.addEditQuestion && this.addEditQuestion.autoSave) {
        this.$emit("onCancelAfterAutoSave");
      }
      this.addEditQuestion = {};
      this.$store.dispatch("selectedActivityQuestionAction", { id: null });
    },
    isQuestionPartOfBranchingLogic(inputQuestion) {
      if (this.activityDetails.questions && this.activityDetails.questions.length > 0) {
        for (const questionIndex in this.activityDetails.questions) {
          const question = this.activityDetails.questions[questionIndex];
          if (question.branchingConfigured == true) {
            if (question.nextQuestionId && question.nextQuestionId == inputQuestion.id) {
              return true;
            }
            if (question.recursiveLoopEndQuestionId && question.recursiveLoopEndQuestionId == inputQuestion.id) {
              //Covers MC MS Recursive branching.
              return true;
            }
            if (question.branchingOptions && question.branchingOptions.length > 0) {
              for (let i = 0; i < question.branchingOptions.length; i++) {
                if (question.branchingOptions[i].nextQuestionId && question.branchingOptions[i].nextQuestionId == inputQuestion.id) {
                  return true;
                }
              }
            }
            if (question.type.toLowerCase() !== "image" && question.options) {
              for (let i = 0; i < question.options.length; i++) {
                if (question.options[i].nextQuestion && question.options[i].nextQuestion == inputQuestion.id) {
                  return true;
                } else if (question.options[i].nextQuestionIdList && question.options[i].nextQuestionIdList.length) {
                  //Covers MC MS Recursive branching.
                  return true;
                }
              }
            } else {
              if (question.languageImageOptions && question.languageImageOptions[0] && question.languageImageOptions[0].options) {
                for (let i = 0; i < question.languageImageOptions[0].options.length; i++) {
                  if (question.languageImageOptions[0].options[i].nextQuestion && question.languageImageOptions[0].options[i].nextQuestion == inputQuestion.id) {
                    return true;
                  }
                }
              }
            }
          }
        }
      }
      return false;
    },
    isBranchingLogicActivity() {
      let branchingLogicEnabled = false;
      if (this.activityDetails.questions && this.activityDetails.questions.length > 0) {
        for (const questionIndex in this.activityDetails.questions) {
          const question = this.activityDetails.questions[questionIndex];
          if (question.branchingConfigured == true) {
            branchingLogicEnabled = true;
            break;
          }
        }
      }
      return branchingLogicEnabled;
    },
    async deleteQuestion() {
      let sectionObj = this.getOldSectionTitle(this.addEditQuestion.id);
      let sectionTitle = !!sectionObj ? sectionObj : this.addEditQuestion.title;
      let isSectionUsedInFormula = await this.getFilteredVariableList(sectionTitle);
      if(isSectionUsedInFormula && this.addEditQuestion.id && this.addEditQuestion.type == "Section"){
        this.showAdvancedScoringWarning(sectionTitle);
      }
      else if (
        activityService.checkBranchingConfiguration(this.addEditQuestion) ||
        this.isQuestionPartOfBranchingLogic(this.addEditQuestion) || this.isBranchingLogicActivity()
      ) {
        swal({
          title: "Please be advised that this activity has a branching logic set up. We suggest you review and revise it as needed. Would you like to continue?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#b8c7ce",
          cancelButtonColor: "#f16559",
          confirmButtonText: "Cancel",
          cancelButtonText: "Yes"
        }).then(({ dismiss }) => {
          if (dismiss === "cancel") {
            this.$store.dispatch("addActivityQuestionAction", null);
            this.addEditQuestion.opType = "delete";
            this.$store.dispatch("addActivityQuestionAction", this.addEditQuestion);
          }
        });
      } else {
        swal({
          title: this.addEditQuestion.type == "Section" ? "Are you sure you want to delete this section?" : "Are you sure you want to delete this step?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#b8c7ce",
          cancelButtonColor: "#f16559",
          confirmButtonText: "Cancel",
          cancelButtonText: "Delete"
        }).then(({ dismiss }) => {
          if (dismiss === "cancel") {
            this.$store.dispatch("addActivityQuestionAction", null);
            this.addEditQuestion.opType = "delete";
            this.$store.dispatch("addActivityQuestionAction", this.addEditQuestion);
          }
        });
      }
    },
    validateImage(image) {
      const isValid = image.name.match(/.(png|jpg|svg)$/i);
      return isValid;
    },
    openInstructionModal() {
      window.$("#instructionModal").modal("show");
    },
    closeModal() {
      window.$("#instructionModal").modal("hide");
    },
    toggleEnglishImageInfoDiv(hide = false) {
      this.useEnglishImageInfoDiv = hide ? false : !this.useEnglishImageInfoDiv;
    },
    toggleUseEnglishImageAnswerCheckbox() {
      // This logic is implemented in image-choice.vue component
    },
    saveExistingGroupInformation(questionId) {
      // call this below function after success of API call
      this.$delete(this.groupsThatAreInEditMode, questionId);
    },
    validateMinutes() {
      if (this.addEditQuestion.maxMinutes < 0) {
        this.addEditQuestion.maxMinutes = 0;
      }
      if (!Number.isInteger(this.addEditQuestion.maxMinutes)) {
        this.addEditQuestion.maxMinutes = Math.floor(this.addEditQuestion.maxMinutes);
      }
    },
    validateSeconds() {
      if (this.addEditQuestion.maxSeconds < 0) {
        this.addEditQuestion.maxSeconds = 0;
      }

      if (this.addEditQuestion.maxSeconds > 60) {
        this.addEditQuestion.maxSeconds = 60;
      }

      if (!Number.isInteger(this.addEditQuestion.maxSeconds)) {
        this.addEditQuestion.maxSeconds = Math.floor(this.addEditQuestion.maxSeconds);
      }
    },
    resetMaxRecordTime() {
      this.addEditQuestion.maxMinutes = 5;
      this.addEditQuestion.maxSeconds = 0;
    },
    startAutoSave() {
      this.autoSaveTimer = setInterval(() => {
        if (window.document.getIdleSecondsCounter() * 1000 == this.autoSaveElementTimeout) {
          this.saveQuestion(true);
        }
      }, 1000);
    },
    stopAutoSave() {
      clearInterval(this.autoSaveTimer);
    },
    resetAutoSave() {
      this.stopAutoSave();
      this.startAutoSave();
    },
    dataFormatNumber(eOld) {
      let e = eOld;
      if (e.indexOf(".") > -1) {
        let decimalNumber = e.split(".");
        if (decimalNumber[1] != undefined && decimalNumber[1].length > 2) {
          decimalNumber = parseFloat(e);
          e = decimalNumber.toFixed(2);
        }
      }

      if (e > this.dataFormatValidation.max) {
        return this.dataFormatValidation.max;
      } else if (e < this.dataFormatValidation.min && e != "") {
        return this.dataFormatValidation.min;
      } else if (Math.round(e * this.dataFormatValidation.decimal) / this.dataFormatValidation.decimal != e) {
        return this.dataFormatLastValue;
      } else {
        this.dataFormatLastValue = e;
        return e;
      }
    },
    clearDataCheck() {
      this.configureDataCheck = [
        {
          check: "",
          type: "",
          value: "",
          hasError: false,
          showDataCheckTypeDropdown: false,
          id: uuidv4(),
          dateValue: "",
          timeValue: ""
        }
      ];
      this.addEditQuestion.dataEditChecks = [];
      this.isDataCheckConfigured=false
    },
    onSelect(selectedOptions){
      this.selectedOptionIds = selectedOptions;
    },
    showAdvancedScoringWarning(title){
      if(this.addEditQuestion.type == "Step"){
        return false
      }
      var stepName = "";
      var type = "";
      let action = "";
      if(this.addEditQuestion.type == "Section"){
        stepName = title;
        type = "Section";
        action = "edit";
      }
      swal({
        title:
          `“` + `${stepName}` + `”` + " is being used in custom variables\n for Advanced Scoring.\n\n You cannot " + `${action}` + " this " + `${type}` + " until you remove\n it from the formulas.",
        type: "warning",
        showCancelButton: false,
        confirmButtonColor: "#4c8ce4",
        confirmButtonText: "I understand",
        customClass: "custom-cancel",
        reverseButtons: true,
        allowOutsideClick: false,
        showCloseButton: true
      }).then(({ dismiss }) => {
        this.disableSaveBtn = false;
      })
    },
    async getFilteredVariableList(title){
      let filterName = "";
      let activityId = this.activityData.activityId;
      if(this.addEditQuestion.type == "Section"){
        filterName = title.replace(/ /g,"_");
      }
      else{
        filterName = "Step_" + this.addEditQuestion.stepSequence;
      }
      let isStepUsedInFormula = false;
      let pathParams = { activityRevisionId: activityId };
      let queryParams = { name: filterName };
      await this.$api.getFilterVariableDetails(pathParams,queryParams).then(response => {
        let responseData = response.body.variables;
        if (responseData && responseData.length > 0){
          isStepUsedInFormula = true;
        }
      },error => {
        this.disableSaveBtn = false;
        this.$toastr.error(
            error.body && error.body.message
                ? error.body.message
                : "Error while getting filter variables details."
        );
      });
      return isStepUsedInFormula;
    },
    getOldSectionTitle(id){
      let sectionObject = this.activityData.questions.filter(ques=>{
        return (ques.type === "Section" && ques.id === id)
      })
      if(sectionObject && sectionObject.length > 0){
        return sectionObject[0].title;
      }
      else{
        return '';
      }
    }
  },
  components: {
    datepicker: Datepicker,
    IntegerPlusminus,
    VueTimepicker,
    ActivityStepsEdit,
    MultiSelectWithSearch
  },
  created() {
    this.addEditQuestion.canRestrainLength = true;
  },
  beforeDestroy() {
    this.stopAutoSave();
  }
};
</script>

<style scoped lang="scss">
// Style for quick fixes bootstrap after migration (before redesign should be removed)
.fa,
.far,
.fas {
  font-family: "FontAwesome";
}
body {
  color: #333;
}

.h2,
h2 {
  font-size: 30px;
  margin: 20px 0 10px;
}

.h3,
h3 {
  font-size: 24px;
  color: #333;
}

.h5,
h5 {
  // opacity: 0.7;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: normal;
  // color: #666769;
}

.h6,
h6 {
  font-size: 12px;
  margin: 10px 0;
  color: #333;
}

.btn {
  font-size: 14px;
}

.col-xs-12 {
  width: 100%;
}

.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  float: left;
  //flex: none;
  display: block;
}

.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}

.image-capture-model {
  padding: 0px 17px 32px !important;
}

.col-xs-10 {
  width: 83.33333333%;
}
.img-border {
  border: 1px solid #000000;
}
.panel-default {
  border-color: #ddd;
}

.panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}
.modal-heading-text {
  width: 270px;
  padding-bottom: 20px;
}
.position-relative {
  position: relative;
}
.custom-image-pixels {
  width: 168px !important;
  height: 128px !important;
}
.add_edit_question_card {
  background-color: #f5f8fa;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #d3dfe4;
  padding: 16px;
}

.instruction {
  color: #959fa4;
  font-size: 12px;
  margin-top: 10px;
  ul {
    padding-left: 14px;
  }
}
.link-text {
  width: 175px;
  display: inline-block;
  margin-top: 5px;
  text-decoration: none;
  color: #007bff;
  cursor: pointer;
}

.upload_btn {
  width: 80px !important;
  height: 30px !important;
  position: relative;
  z-index: 99;
}
.mar-top15 {
  margin-top: 15px !important;
}

.row {
  display: block;

  &:after {
    content: "";
    clear: both;
    display: block;
  }
}

.color_959fa4 {
  color: #959fa4 !important;
}

.quill-score {
  width: 97%;
}
/deep/ .quill-editor {
  &.bg-white {
    position: relative;
    border: solid 2px #d3dfe4;
    border-radius: 3px;
    .ql-container {
      &.ql-snow {
        border: none;
      }
    }
    .ql-toolbar {
      &.ql-snow {
        border-bottom: none;
        border-top: none;
        padding: 4px;
        float: right;
        border-left: none;
        top: -40px !important;
        background-color: rgba(211, 223, 228, 0.5);
        position: absolute;
        right: 0;
        border-right: 0px;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        .ql-formats {
          margin-right: 0px;
          border: 1px solid #ccc;
          border-radius: 2px;
          margin-right: 10px;
          button {
            height: auto;
            padding: 4px 4px;
          }
          button:not(:last-child) {
            border-right: 1px solid #ccc;
          }
        }
        .ql-formats:last-child {
          border-right: 1px solid #ccc;
        }
        .ql-stroke {
          stroke: #959fa4;
        }
        .ql-fill,
        .ql-snow .ql-stroke.ql-fill {
          fill: #ccc;
        }
      }
    }
    .ql-container {
      .ql-editor {
        height: auto;
        min-height: 0px;
      }
    }
  }
  &.instruction-screen {
    .ql-toolbar {
      &.ql-snow {
        top: -43px;
        .ql-formats {
          margin-top: 0px;
        }
      }
    }
    .ql-container {
      .ql-editor {
        min-height: 100px;
      }
    }
  }
}

.modal_header_color {
  font-weight: 600;
  color: #666669;
  font-size: 24px !important;
}
.modal_desc {
  color: #535456;
  margin-bottom: 0.7rem;
}
.modal_custom {
  border-radius: 4px;
  padding: 16px;
}
.selectLibrary {
  border-radius: 3px;
  background-color: #ddd;
  padding: 5px;
  overflow: hidden;
  border: none;
  font-weight: 500;
  font-size: 14px;
  color: #555;
  width: 100%;
}
.selectLibrary:focus {
  outline: none;
}
.library_add_btn {
  max-width: 300px;
  margin: auto;
  height: 38px;
}
.paginate {
  color: grey;
  font-size: 14px;
  background-color: white;
  margin: 0px 8px 0px 0px;
  padding: 8px 5px 8px 5px;
  display: inline-block;
  cursor: pointer;
}
.active {
  color: #4c8ce4;
  font-size: 14px;
  font-weight: bolder;
}
.library_img_bg {
  display: flex;
  background-color: #ececec;
  border: solid 1px #d3dfe4;
  max-width: 121px;
  max-height: 70px;
  min-height: 70px;
  margin: 4px;
  text-align: -webkit-center;
  .logo {
    width: auto;
    margin: auto;
    height: 45px;
  }
  .icon {
    max-width: 50px;
    max-height: 62px;
    margin: auto;
  }
}
.selected_icon_logo_image {
  background-color: #4c8ce4;
  img {
    -webkit-filter: brightness(0) invert(1);
    filter: brightness(0) invert(1);
  }
}

@media (min-width: 768px) {
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12 {
    float: left;
    display: block;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-10 {
    width: 100%;
  }
  .col-sm-4 {
    width: 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-md-2 {
    flex: none;
  }
}

@media (min-width: 992px) {
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12 {
    float: left;
    flex: none;
  }
  .col-md-2 {
    width: 16.66666667%;
  }
  .col-md-10 {
    width: 83.33333333%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-lg-offset-4 {
    margin-left: 33.33333333%;
  }
}

@media (min-width: 1200px) {
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12 {
    float: left;
    display: block;
  }
  .col-lg-2 {
    width: 16.66666667%;
  }
  .col-lg-10 {
    width: 82.33333333%;
  }
  .col-lg-11 {
    width: 91.66666667%;
  }
}

// END of style for quick fixes bootstrap after migration (before redesign should be removed)

.add_edit_question_card {
  background-color: #f5f8fa;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #d3dfe4;
  padding: 16px;
  margin-bottom: 20px;
  display: block;
  .type_select {
    border-radius: 0 !important;
    width: 100%;
  }
  .options_section {
    background-color: #eaf0f4;
    border: solid 1px #e2e7ea;
    display: inline-block;
    width: 100%;
    border-radius: 2px;
    padding: 10px 7px;
    margin: 10px 0 0;
  }
  .show-dropdown {
    left: 175px;
    position: relative;
    bottom: 40px;
  }
  .remove-check {
    position: absolute;
    bottom: 2px;
    left: 22rem;
    cursor: pointer;
  }
  .limit_text_input {
    position: absolute;
    top: -5px;
    line-height: 1;
    left: 135px;
    width: 127px;
    height: 26px;
    margin-left: 12px;
  }
  .limit_select_input {
    bottom: 2px;
    width: 140px;
  }
  .add_edit_question_card .limit_select_input {
    background-color: unset !important;
  }
  .add-another {
    position: absolute;
    bottom: 2rem;
    font-size: 12px;
    left: 35rem;
    width: max-content;
    color: #4c8ce4;
    cursor: pointer;
  }
  .answer_label_text_input {
    width: 127px;
  }
  .min_value_input {
    width: 50px;
  }
  .max_value_input {
    left: 210px;
    width: 50px;
  }
  .min_max_to_text {
    position: absolute;
    top: 0px;
    left: 204px;
  }
  .add_another_answer {
    font-size: 12px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;
    a {
      color: #4c8ce4;
      cursor: pointer;
    }
  }
  label {
    font-weight: normal;
    margin-bottom: 10px;
  }
  .multi_choice_type {
    padding-top: 5px;
  }
  .scale_choice_type {
    padding-top: 5px;
    .radio-style {
      margin: 0;
    }
  }
  .text_choice_type {
    padding-top: 0px;
  }
  .number_choice_type {
    padding-top: 5px;
  }
  .date_time_type {
    padding-top: 5px;
    label {
      width: auto;
      margin-right: 15px;
    }
  }
  .save_btn {
    width: 100px;
  }
  .branch_section {
    position: relative;
    top: -20px;
  }
  .form-control,
  .input-text {
    border-radius: 2px !important;
    padding: 0.375rem 0.275rem;
    border: solid 2px #d3dfe4;
  }
  .file_container [type="file"] {
    cursor: inherit;
    display: block;
    font-size: 20px;
    filter: alpha(opacity=0);
    width: 80px;
    height: 31px;
    max-height: 50px;
    max-width: 300px;
    opacity: 0;
    position: absolute;
    right: 0;
    text-align: right;
    top: 0px;
    left: 0px;
    z-index: 100;
  }
  .file_container [type="file"].language-img-file {
    cursor: inherit;
    display: block;
    filter: alpha(opacity=0);
    opacity: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
    height: auto;
    border: 1px solid red;
    font-size: initial;
  }
  .file_container {
    padding: 0px 10px 0 0;
    color: grey;
  }
  .file_container [type="file"] {
    cursor: pointer;
  }
  .file_container_text {
    background-color: #d3dfe4;
    padding: 5px;
    width: 100%;
    display: block;
    border-radius: 4px;
    text-align: center;
    color: #959fa4;
  }
  .error-style {
    font-size: 12px;
    color: #ff4848;
    padding-bottom: 5px;
    padding-left: 0;
  }
  .text-style {
    padding: 9px 0px 0 0;
    font-size: 12px;
    color: #959fa4;
  }
  .img_size {
    width: 100%;
    height: 100%;
    border: 1px solid #d3dfe4;
  }
  @media (max-width: 575px) {
    .col-sm-12 {
      padding: 0px;
    }
    .branch_section {
      padding-top: 25px;
    }
  }
  @media (min-width: 576px) and (max-width: 767px) {
    .col-sm-12 {
      padding: 0px;
    }
    .branch_section {
      padding-top: 25px;
    }
    .text-style {
      padding: 0 0 20px 0;
    }
  }
  @media (min-width: 768px) and (max-width: 991px) {
    .col-sm-12 {
      padding: 0px;
    }
    .branch_section {
      padding-top: 25px;
    }
    .text-style {
      padding: 0 0 20px 0;
    }
  }
  @media (min-width: 992px) and (max-width: 1199px) {
    .branch_section {
      padding-right: 0;
    }
  }
  @media (min-width: 1200px) {
    .branch_section {
      padding-right: 0;
    }
    .gpskin-example-link {
      margin-left: 15px;
    }
  }
}

//for instruction type
.file_container1 [type="file"] {
  cursor: pointer;
  display: block;
  font-size: 20px;
  filter: alpha(opacity=0);
  width: 100px;
  height: 40px;
  max-height: 50px;
  max-width: 200px;
  opacity: 0;
  position: absolute;
  right: 0;
  text-align: right;
  top: 0;
  left: 0;
}
.file_container1 {
  margin-top: 5px;
  color: #555;
}
.file_container1 [type="file"] {
  cursor: pointer;
}
.file_container_text1 {
  background-color: #ddd;
  padding: 5px;
  width: 100%;
  display: block;
  border-radius: 4px;
  text-align: center;
}
.info-circle {
  padding-left: 15px;
}

.info-circle-div {
  width: 280px;
  height: auto;
  background-color: #ffffff;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #666669;
  padding: 13px 16px 19px 13px;
  position: absolute;
  border-radius: 3px;
  box-shadow: 1px 1px #d3deef;
  display: inline-block;
  vertical-align: text-top;
  margin-left: 10px;
}

.wong-baker-info-circle-div {
  width: 300px;
  height: 90px;
  background-color: #ffffff;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #666669;
  padding: 13px;
  position: absolute;
  border-radius: 3px;
  margin-left: 20px;
  margin-top: 0px;
  -webkit-box-shadow: 1px 1px #d3deef;
  box-shadow: 1px 1px #d3deef;
  z-index: 100;
}

.map-info-circle-div {
  width: 280px;
  height: 80px;
  background-color: #ffffff;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #666669;
  padding: 13px 16px 19px 13px;
  position: absolute;
  border-radius: 3px;
  margin-left: 110px;
  margin-top: -10px;
  box-shadow: 1px 1px #d3deef;
  z-index: 100;
}

.info-circle-log-entry-div {
  width: 280px;
  height: 80px;
  background-color: #ffffff;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #666669;
  padding: 13px 16px 19px 13px;
  position: absolute;
  border-radius: 3px;
  margin-left: 240px;
  margin-top: -35px;
  box-shadow: 1px 1px #d3deef;
  z-index: 100;
}

.color_red {
  padding-top: 0px;

  img {
    vertical-align: middle;
    /* border-style: none; */
    padding: 8px;
    border: 1px solid #d3dfe4;
    background: #d3dfe4;
    opacity: 0.6;
    border-radius: 3px;
  }
}

.col-sm-10 {
  max-width: 100%;
}

.form-group {
  margin-bottom: 10px;
}

.form-control::placeholder {
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #c5d1d6;
}

.btn-success {
  height: 36px;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

/*checkbox data*/
input[type="checkbox"] + span {
  display: block;
}

input[type="checkbox"] {
  display: none;
  height: 26px;
  width: 26px;
}
input[type="checkbox"] + span:before {
  content: "\2714";
  border: 0.1em solid #d3dfe4;
  border-radius: 3px;
  width: 21px;
  display: inline-block;
  height: 21px;
  padding-left: 5px;
  margin-right: 7px;
  color: transparent;
  background-color: #fff;
}

input[type="checkbox"]:checked + span:before {
  background-color: #4c8ce4;
  border: 0.1em solid #4c8ce4;
  color: #fff;
  font-size: 14px;
  padding-bottom: 5px;
}

.example {
  color: #4c8ce4;
  cursor: pointer;
}

.cancelImage {
  color: rgba(0, 0, 0, 0.4) !important;
  float: right;
  font-size: 18px;
  cursor: pointer;
}

.scale-info {
  opacity: 0.7;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #666669;
}

.scale-info-div {
  margin-left: 105px !important;
  bottom: 104px !important;
  width: 360px !important;
}

.score-info-div {
  margin-left: 190px !important;
  width: 250px !important;
  height: 100px !important;
}
.length-info-div {
  margin-left: 90px !important;
  width: 250px !important;
  height: 75px !important;
  margin-top: 42px !important;
  z-index: 1000;
}
.restrain-info-div {
  margin-left: 150px !important;
  width: 200px !important;
  z-index: 1000;
}

.gp-help-text {
  font-size: 12px;
  color: #666669;
  opacity: 0.67;
}

.img-placeholder {
  background: #fff;
  border: 2px dashed #d3dee3;
  display: block;
  padding: 20px 5px;
  color: 666669;
  opacity: 0.7;
  font-size: 12px;
  border-radius: 3px;
}
.use-english-img {
  .info-circle-div {
    margin-left: 400px;
  }
}
.soft_max.max_value_input {
  left: 238px !important;
}
span.soft_min_to.min_max_to_text {
  left: 230px !important;
}
.soft_min.min_value_input {
  left: 160px !important;
}
.unit_input {
  left: 75px !important;
}
.select-completedby {
  width: 200px;
}
.image_score_text,
.image_score_input {
  left: 0px;
}

.score_text {
  position: absolute;
  top: 0px;
  left: 10px;
}
.score_input {
  position: absolute;
  left: 9px;
  top: 25px;
  height: 40px;
  width: 110px;
}
.inner-card-value {
  font-size: 14px !important;
  color: #4a4a4a;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  width: 100%;
}

.setting-btn-text {
  position: relative;
  right: 5px;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: #b0bac9;
}

.switch-option {
  float: left;
  width: 100%;
}

.switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 23px;
  float: left;
  margin-right: 10px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #ccc;
}

.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1px;
  background-color: #ccc;
}
input:checked + .slider {
  border: 2px solid #48bf7a;
}
input:checked + .slider:before {
  content: "";
  background-color: #48bf7a;
}
input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}
input:checked + .slider:before {
  /*content: '✓';*/
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}

h5.question,
h5.answer {
  top: 30px;
  position: relative;
}
.scale-right {
  top: 30px;
}
.section_weight input {
  background-color: #eee;
  border-radius: 3px;
  color: #000;
  line-height: 26px;
  border: none;
  padding: 0 10px;
  text-align: right;
  width: 100%;
  height: 32px;
}
input.group-scoring__name-input {
  width: 100%;
  height: 33px;
  border-radius: 4px;
  border: solid 1px #4c8ce4;
  background-color: #ffffff;
}
.save_sec_btn {
  height: 33px;
  border-radius: 5px;
  padding: 0 15px;
  color: #fff;
  border: none;
  background-color: #4c8ce4;
  width: 79%;
  float: left;
}
.group-scoring__weights-section {
  line-height: 30px;
}
button.int-pm-btn {
  width: 32px;
}
.int-pm .int-pm-value {
  background-color: #fff !important;
  width: 45px !important;
  padding: 10px 10px !important;
}
.score_cls {
  margin-left: -3%;
}

.score_cls_vas {
  margin-left: 4%;
}

h5.operator_text {
  opacity: 1;
}
.start-date input {
  height: 40px;
  border-radius: 3px !important;
  border: solid 2px #d3dfe4 !important;
  font-size: 14px;
}

.set_score {
  width: 200px;
  display: block;
}

.set_score .score_text {
  clear: both;
  float: left;
  position: unset;
}

.width-50 {
  width: 50%;
  float: left;
}
.width-40 {
  width: 40%;
  float: left;
}
.delete-section {
  line-height: 32px;
  text-align: left;
  position: relative;
  right: 10px;
  color: #f16559 !important;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 4px;
    &:hover{
      background-color: rgba(241, 101, 89, 0.15);
    }
}
</style>

<style>
.vue__time-picker {
  display: inline-block;
  position: relative;
  font-size: 1em;
  width: 10em;
  font-family: sans-serif;
  vertical-align: middle;
}
.vue__time-picker * {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.vue__time-picker input.display-time {
  border: 2px solid #d3dfe4 !important;
  border-radius: 0 !important;
  width: 10em;
  height: 2.2em !important;
  padding: 0.3em 0.5em;
  font-size: 1em;
}
.vue__time-picker input.has-custom-icon {
  padding-left: 1.8em;
}
.vue__time-picker input.display-time.invalid:not(.skip-error-style) {
  border-color: #c03;
  outline-color: #c03;
}
.vue__time-picker input.display-time.disabled,
.vue__time-picker input.display-time:disabled {
  color: #d2d2d2;
}
.vue__time-picker .controls {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 3;
  -webkit-box-orient: horizontal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  pointer-events: none;
}
.vue__time-picker .controls,
.vue__time-picker .controls > * {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-direction: normal;
}
.vue__time-picker .controls > * {
  cursor: pointer;
  width: auto;
  -webkit-box-orient: vertical;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 0.35em;
  color: #d2d2d2;
  line-height: 100%;
  font-style: normal;
  pointer-events: auto;
  -webkit-transition: color 0.2s, opacity 0.2s;
  transition: color 0.2s, opacity 0.2s;
}
.vue__time-picker .controls > :hover {
  color: #797979;
}
.vue__time-picker .controls > :active,
.vue__time-picker .controls > :focus {
  outline: 0;
}
.vue__time-picker .controls .char {
  font-size: 1.1em;
  line-height: 100%;
  -webkit-margin-before: -0.15em;
}
.vue__time-picker .custom-icon {
  z-index: 2;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 1.8em;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  pointer-events: none;
}
.vue__time-picker .controls img,
.vue__time-picker .controls svg,
.vue__time-picker .custom-icon img,
.vue__time-picker .custom-icon svg {
  display: inline-block;
  vertical-align: middle;
  margin: 0;
  border: 0;
  outline: 0;
  max-width: 1em;
  height: auto;
}
.vue__time-picker .time-picker-overlay {
  z-index: 4;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.vue__time-picker .dropdown {
  position: absolute;
  z-index: 5;
  top: calc(2.2em + 2px);
  left: 0;
  background: #fff;
  -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.15);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.15);
  width: 10em;
  height: 10em;
  font-weight: 400;
}
.vue__time-picker .dropdown.drop-up {
  top: auto;
  bottom: calc(2.2em + 1px);
}
.vue__time-picker .dropdown .select-list {
  width: 10em;
  height: 10em;
  overflow: hidden;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.vue__time-picker .dropdown .select-list:active,
.vue__time-picker .dropdown .select-list:focus {
  outline: 0;
}
.vue__time-picker .dropdown ul {
  padding: 0;
  margin: 0;
  list-style: none;
  outline: 0;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0.00001px;
  flex: 1 1 0.00001px;
  overflow-x: hidden;
  overflow-y: auto;
}
.vue__time-picker .dropdown ul.apms,
.vue__time-picker .dropdown ul.minutes,
.vue__time-picker .dropdown ul.seconds {
  border-left: 1px solid #fff;
}
.vue__time-picker .dropdown ul li {
  list-style: none;
  text-align: center;
  padding: 0.3em 0;
  color: #161616;
}
.vue__time-picker .dropdown ul li:not(.hint):not([disabled]):focus,
.vue__time-picker .dropdown ul li:not(.hint):not([disabled]):hover {
  background: rgba(0, 0, 0, 0.08);
  color: #161616;
  cursor: pointer;
}
.vue__time-picker .dropdown ul li:not([disabled]).active,
.vue__time-picker .dropdown ul li:not([disabled]).active:focus,
.vue__time-picker .dropdown ul li:not([disabled]).active:hover {
  background: #41b883;
  color: #fff;
}
.vue__time-picker .dropdown ul li[disabled],
.vue__time-picker .dropdown ul li[disabled]:hover {
  background: transparent;
  opacity: 0.3;
  cursor: not-allowed;
}
.vue__time-picker .dropdown .hint {
  color: #a5a5a5;
  cursor: default;
  font-size: 0.8em;
}
.disabled_datepicker {
  pointer-events: none;
  opacity: 0.5;
}
.datepicker-class {
  background-color: #eee !important;
}

.col-lg-9.survey_instruction_question .score_cls {
  margin-left: -6%;
}
.col-lg-9.survey_instruction_question .quill-score {
  width: 93%;
}
.col-lg-9.scale-quill {
  max-width: 81% !important;
  width: 81% !important;
}
.col-lg-9.survey_instruction_question .scale-quill {
  max-width: 77% !important;
  width: 77% !important;
}
.score_skiped {
  margin-top: -7px;
}
.col-lg-3 .form-control.type_select {
  border: solid 2px #d4d9de;
  background-image: url(/static/img/arrow-down-dark.png);
}
.form-control.type_select option {
  color: #495057;
}
.form-control.type_select option:first-child {
  color: #c7cfd9;
}
.placeholder {
  color: #c7cfd9;
}
.col-md-4 .option-section {
  width: 100% !important;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 550px;
    margin: 1.75rem auto;
  }
}
.add_another_data_check {
  font-size: 12px;
  font-weight: bold;
  color: #4c8ce4;
  cursor: pointer;
}
.activity-type-select {
  width: 100%;
  font-size: 12px;
  border: none;
  height: 35px;
  border-radius: 3px;
  background-color: #ffff;
  color: #666669;
}

.selectBox {
  position: relative;
}

.selectBox select {
  width: 100%;
}

.overSelect {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.input-style.limit_select_input::placeholder {
  line-height: 26px;
}
.input-style.limit_select_input {
  height: 35px;
  padding: 2px 5px 0px 10px !important;
  bottom: 0 !important;
}
.col-sm-1.delete_button {
  width: 50px;
}
.group-tag-label{
  opacity: 0.7;
  font-size: 14px;
}
.add-group-tag{
  margin-left: -12px;
}
.cancel_sec_btn{
  width: auto;
  height: 33px;
  border-radius: 5px;
  padding: 0 15px;
  color: #4c8ce4;
  border: none;
  background-color: #fff;
  float: left;
}
</style>
